/* eslint-disable */
import { languageTag } from "./runtime.js"
import * as ru from "./messages/ru.js"
import * as en from "./messages/en.js"


/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const meta_title = (params = {}, options = {}) => {
	return {
		en: en.meta_title,
		ru: ru.meta_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const btn_apply = (params = {}, options = {}) => {
	return {
		en: en.btn_apply,
		ru: ru.btn_apply
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const btn_cancel = (params = {}, options = {}) => {
	return {
		en: en.btn_cancel,
		ru: ru.btn_cancel
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const btn_delete = (params = {}, options = {}) => {
	return {
		en: en.btn_delete,
		ru: ru.btn_delete
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const btn_add = (params = {}, options = {}) => {
	return {
		en: en.btn_add,
		ru: ru.btn_add
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const btn_save = (params = {}, options = {}) => {
	return {
		en: en.btn_save,
		ru: ru.btn_save
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const btn_download = (params = {}, options = {}) => {
	return {
		en: en.btn_download,
		ru: ru.btn_download
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const btn_send = (params = {}, options = {}) => {
	return {
		en: en.btn_send,
		ru: ru.btn_send
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const btn_close = (params = {}, options = {}) => {
	return {
		en: en.btn_close,
		ru: ru.btn_close
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const btn_change = (params = {}, options = {}) => {
	return {
		en: en.btn_change,
		ru: ru.btn_change
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const btn_build = (params = {}, options = {}) => {
	return {
		en: en.btn_build,
		ru: ru.btn_build
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const btn_save_and_rerun = (params = {}, options = {}) => {
	return {
		en: en.btn_save_and_rerun,
		ru: ru.btn_save_and_rerun
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const btn_subscribe = (params = {}, options = {}) => {
	return {
		en: en.btn_subscribe,
		ru: ru.btn_subscribe
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const btn_reissue = (params = {}, options = {}) => {
	return {
		en: en.btn_reissue,
		ru: ru.btn_reissue
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const btn_buy = (params = {}, options = {}) => {
	return {
		en: en.btn_buy,
		ru: ru.btn_buy
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const select_default = (params = {}, options = {}) => {
	return {
		en: en.select_default,
		ru: ru.select_default
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const datepicker_pick_date = (params = {}, options = {}) => {
	return {
		en: en.datepicker_pick_date,
		ru: ru.datepicker_pick_date
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const datepicker_pick_date_range = (params = {}, options = {}) => {
	return {
		en: en.datepicker_pick_date_range,
		ru: ru.datepicker_pick_date_range
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const datepicker_min = (params = {}, options = {}) => {
	return {
		en: en.datepicker_min,
		ru: ru.datepicker_min
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const datepicker_hours = (params = {}, options = {}) => {
	return {
		en: en.datepicker_hours,
		ru: ru.datepicker_hours
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const form_date_picker_from = (params = {}, options = {}) => {
	return {
		en: en.form_date_picker_from,
		ru: ru.form_date_picker_from
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const form_date_picker_to = (params = {}, options = {}) => {
	return {
		en: en.form_date_picker_to,
		ru: ru.form_date_picker_to
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ N: NonNullable<unknown> }} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const form_date_picker_last_N_minutes = (params , options = {}) => {
	return {
		en: en.form_date_picker_last_N_minutes,
		ru: ru.form_date_picker_last_N_minutes
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ N: NonNullable<unknown> }} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const form_date_picker_last_N_hours = (params , options = {}) => {
	return {
		en: en.form_date_picker_last_N_hours,
		ru: ru.form_date_picker_last_N_hours
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ N: NonNullable<unknown> }} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const form_date_picker_last_N_hours_plural = (params , options = {}) => {
	return {
		en: en.form_date_picker_last_N_hours_plural,
		ru: ru.form_date_picker_last_N_hours_plural
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ N: NonNullable<unknown> }} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const form_date_picker_last_N_hours_plural_2 = (params , options = {}) => {
	return {
		en: en.form_date_picker_last_N_hours_plural_2,
		ru: ru.form_date_picker_last_N_hours_plural_2
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const field_name = (params = {}, options = {}) => {
	return {
		en: en.field_name,
		ru: ru.field_name
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const disk_select_name = (params = {}, options = {}) => {
	return {
		en: en.disk_select_name,
		ru: ru.disk_select_name
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const required_field = (params = {}, options = {}) => {
	return {
		en: en.required_field,
		ru: ru.required_field
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const no_spaces = (params = {}, options = {}) => {
	return {
		en: en.no_spaces,
		ru: ru.no_spaces
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ maxLength: NonNullable<unknown> }} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const max_length = (params , options = {}) => {
	return {
		en: en.max_length,
		ru: ru.max_length
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ minLength: NonNullable<unknown> }} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const min_length = (params , options = {}) => {
	return {
		en: en.min_length,
		ru: ru.min_length
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ maxNumber: NonNullable<unknown> }} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const max_number = (params , options = {}) => {
	return {
		en: en.max_number,
		ru: ru.max_number
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ minNumber: NonNullable<unknown> }} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const min_number = (params , options = {}) => {
	return {
		en: en.min_number,
		ru: ru.min_number
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const data_table_pagination_rpp = (params = {}, options = {}) => {
	return {
		en: en.data_table_pagination_rpp,
		ru: ru.data_table_pagination_rpp
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const data_table_pagination_page = (params = {}, options = {}) => {
	return {
		en: en.data_table_pagination_page,
		ru: ru.data_table_pagination_page
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const data_table_noResults = (params = {}, options = {}) => {
	return {
		en: en.data_table_noResults,
		ru: ru.data_table_noResults
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const header_user_exit = (params = {}, options = {}) => {
	return {
		en: en.header_user_exit,
		ru: ru.header_user_exit
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const header_balance = (params = {}, options = {}) => {
	return {
		en: en.header_balance,
		ru: ru.header_balance
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const header_lang = (params = {}, options = {}) => {
	return {
		en: en.header_lang,
		ru: ru.header_lang
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const api_error_somethingWentWrong = (params = {}, options = {}) => {
	return {
		en: en.api_error_somethingWentWrong,
		ru: ru.api_error_somethingWentWrong
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const api_success = (params = {}, options = {}) => {
	return {
		en: en.api_success,
		ru: ru.api_success
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const field_error_required = (params = {}, options = {}) => {
	return {
		en: en.field_error_required,
		ru: ru.field_error_required
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const confirm_dialog_title = (params = {}, options = {}) => {
	return {
		en: en.confirm_dialog_title,
		ru: ru.confirm_dialog_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const confirm_dialog_yes = (params = {}, options = {}) => {
	return {
		en: en.confirm_dialog_yes,
		ru: ru.confirm_dialog_yes
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const confirm_dialog_no = (params = {}, options = {}) => {
	return {
		en: en.confirm_dialog_no,
		ru: ru.confirm_dialog_no
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const api_status_toast_success = (params = {}, options = {}) => {
	return {
		en: en.api_status_toast_success,
		ru: ru.api_status_toast_success
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const api_status_toast_error = (params = {}, options = {}) => {
	return {
		en: en.api_status_toast_error,
		ru: ru.api_status_toast_error
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const api_status_toast_success_delete = (params = {}, options = {}) => {
	return {
		en: en.api_status_toast_success_delete,
		ru: ru.api_status_toast_success_delete
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const api_token_already_exists = (params = {}, options = {}) => {
	return {
		en: en.api_token_already_exists,
		ru: ru.api_token_already_exists
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const unit_GB = (params = {}, options = {}) => {
	return {
		en: en.unit_GB,
		ru: ru.unit_GB
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_default_hint = (params = {}, options = {}) => {
	return {
		en: en.project_status_default_hint,
		ru: ru.project_status_default_hint
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_null = (params = {}, options = {}) => {
	return {
		en: en.project_status_null,
		ru: ru.project_status_null
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_null_hint = (params = {}, options = {}) => {
	return {
		en: en.project_status_null_hint,
		ru: ru.project_status_null_hint
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_CREATING = (params = {}, options = {}) => {
	return {
		en: en.project_status_CREATING,
		ru: ru.project_status_CREATING
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_CREATING_hint = (params = {}, options = {}) => {
	return {
		en: en.project_status_CREATING_hint,
		ru: ru.project_status_CREATING_hint
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_EMPTY = (params = {}, options = {}) => {
	return {
		en: en.project_status_EMPTY,
		ru: ru.project_status_EMPTY
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_EMPTY_hint = (params = {}, options = {}) => {
	return {
		en: en.project_status_EMPTY_hint,
		ru: ru.project_status_EMPTY_hint
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_BUILD_STARTED = (params = {}, options = {}) => {
	return {
		en: en.project_status_BUILD_STARTED,
		ru: ru.project_status_BUILD_STARTED
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_BUILD_STARTED_hint = (params = {}, options = {}) => {
	return {
		en: en.project_status_BUILD_STARTED_hint,
		ru: ru.project_status_BUILD_STARTED_hint
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_BUILD_STOPPED = (params = {}, options = {}) => {
	return {
		en: en.project_status_BUILD_STOPPED,
		ru: ru.project_status_BUILD_STOPPED
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_BUILD_FAILED = (params = {}, options = {}) => {
	return {
		en: en.project_status_BUILD_FAILED,
		ru: ru.project_status_BUILD_FAILED
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_BUILD_FAILED_hint = (params = {}, options = {}) => {
	return {
		en: en.project_status_BUILD_FAILED_hint,
		ru: ru.project_status_BUILD_FAILED_hint
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_DEPLOYING = (params = {}, options = {}) => {
	return {
		en: en.project_status_DEPLOYING,
		ru: ru.project_status_DEPLOYING
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_DEPLOYING_hint = (params = {}, options = {}) => {
	return {
		en: en.project_status_DEPLOYING_hint,
		ru: ru.project_status_DEPLOYING_hint
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_DEPLOY_FAILED = (params = {}, options = {}) => {
	return {
		en: en.project_status_DEPLOY_FAILED,
		ru: ru.project_status_DEPLOY_FAILED
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_DEPLOY_FAILED_hint = (params = {}, options = {}) => {
	return {
		en: en.project_status_DEPLOY_FAILED_hint,
		ru: ru.project_status_DEPLOY_FAILED_hint
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_STARTING = (params = {}, options = {}) => {
	return {
		en: en.project_status_STARTING,
		ru: ru.project_status_STARTING
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_STARTING_hint = (params = {}, options = {}) => {
	return {
		en: en.project_status_STARTING_hint,
		ru: ru.project_status_STARTING_hint
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_RUN_ERROR = (params = {}, options = {}) => {
	return {
		en: en.project_status_RUN_ERROR,
		ru: ru.project_status_RUN_ERROR
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_RUN_PROBLEM = (params = {}, options = {}) => {
	return {
		en: en.project_status_RUN_PROBLEM,
		ru: ru.project_status_RUN_PROBLEM
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_RUN_PROBLEM_hint = (params = {}, options = {}) => {
	return {
		en: en.project_status_RUN_PROBLEM_hint,
		ru: ru.project_status_RUN_PROBLEM_hint
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_RUN_ERROR_hint = (params = {}, options = {}) => {
	return {
		en: en.project_status_RUN_ERROR_hint,
		ru: ru.project_status_RUN_ERROR_hint
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_RUNNING = (params = {}, options = {}) => {
	return {
		en: en.project_status_RUNNING,
		ru: ru.project_status_RUNNING
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_RUNNING_hint = (params = {}, options = {}) => {
	return {
		en: en.project_status_RUNNING_hint,
		ru: ru.project_status_RUNNING_hint
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_STOPPED = (params = {}, options = {}) => {
	return {
		en: en.project_status_STOPPED,
		ru: ru.project_status_STOPPED
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_STOPPED_hint = (params = {}, options = {}) => {
	return {
		en: en.project_status_STOPPED_hint,
		ru: ru.project_status_STOPPED_hint
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_STOPPING = (params = {}, options = {}) => {
	return {
		en: en.project_status_STOPPING,
		ru: ru.project_status_STOPPING
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_FROZEN = (params = {}, options = {}) => {
	return {
		en: en.project_status_FROZEN,
		ru: ru.project_status_FROZEN
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_FROZEN_hint = (params = {}, options = {}) => {
	return {
		en: en.project_status_FROZEN_hint,
		ru: ru.project_status_FROZEN_hint
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_STOPPED_WITH_ERROR = (params = {}, options = {}) => {
	return {
		en: en.project_status_STOPPED_WITH_ERROR,
		ru: ru.project_status_STOPPED_WITH_ERROR
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_STOPPED_WITH_ERROR_hint = (params = {}, options = {}) => {
	return {
		en: en.project_status_STOPPED_WITH_ERROR_hint,
		ru: ru.project_status_STOPPED_WITH_ERROR_hint
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_SCALING = (params = {}, options = {}) => {
	return {
		en: en.project_status_SCALING,
		ru: ru.project_status_SCALING
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_SCALING_hint = (params = {}, options = {}) => {
	return {
		en: en.project_status_SCALING_hint,
		ru: ru.project_status_SCALING_hint
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_clusterHealthyState = (params = {}, options = {}) => {
	return {
		en: en.project_status_clusterHealthyState,
		ru: ru.project_status_clusterHealthyState
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_settingUpPrimary = (params = {}, options = {}) => {
	return {
		en: en.project_status_settingUpPrimary,
		ru: ru.project_status_settingUpPrimary
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_waitingForInstances = (params = {}, options = {}) => {
	return {
		en: en.project_status_waitingForInstances,
		ru: ru.project_status_waitingForInstances
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_creatingNewReplica = (params = {}, options = {}) => {
	return {
		en: en.project_status_creatingNewReplica,
		ru: ru.project_status_creatingNewReplica
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const model_inference_status_active = (params = {}, options = {}) => {
	return {
		en: en.model_inference_status_active,
		ru: ru.model_inference_status_active
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const model_inference_status_inactive = (params = {}, options = {}) => {
	return {
		en: en.model_inference_status_inactive,
		ru: ru.model_inference_status_inactive
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const quota_resourceType_label = (params = {}, options = {}) => {
	return {
		en: en.quota_resourceType_label,
		ru: ru.quota_resourceType_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const quota_resourceClass_label = (params = {}, options = {}) => {
	return {
		en: en.quota_resourceClass_label,
		ru: ru.quota_resourceClass_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const quota_resourceType_VOLUME = (params = {}, options = {}) => {
	return {
		en: en.quota_resourceType_VOLUME,
		ru: ru.quota_resourceType_VOLUME
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ allocated: NonNullable<unknown>, quota: NonNullable<unknown> }} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const quota_allocated_info = (params , options = {}) => {
	return {
		en: en.quota_allocated_info,
		ru: ru.quota_allocated_info
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const upload_dialog_title = (params = {}, options = {}) => {
	return {
		en: en.upload_dialog_title,
		ru: ru.upload_dialog_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const upload_dialog_field_commitMsg = (params = {}, options = {}) => {
	return {
		en: en.upload_dialog_field_commitMsg,
		ru: ru.upload_dialog_field_commitMsg
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const upload_dialog_field_commitMsg_placeholder = (params = {}, options = {}) => {
	return {
		en: en.upload_dialog_field_commitMsg_placeholder,
		ru: ru.upload_dialog_field_commitMsg_placeholder
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const upload_dialog_field_upload_text = (params = {}, options = {}) => {
	return {
		en: en.upload_dialog_field_upload_text,
		ru: ru.upload_dialog_field_upload_text
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const upload_dialog_field_upload_maxSize = (params = {}, options = {}) => {
	return {
		en: en.upload_dialog_field_upload_maxSize,
		ru: ru.upload_dialog_field_upload_maxSize
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const upload_dialog_field_upload_mb = (params = {}, options = {}) => {
	return {
		en: en.upload_dialog_field_upload_mb,
		ru: ru.upload_dialog_field_upload_mb
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const upload_dialog_field_upload_zip = (params = {}, options = {}) => {
	return {
		en: en.upload_dialog_field_upload_zip,
		ru: ru.upload_dialog_field_upload_zip
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const upload_dialog_field_upload_uploadedFiles = (params = {}, options = {}) => {
	return {
		en: en.upload_dialog_field_upload_uploadedFiles,
		ru: ru.upload_dialog_field_upload_uploadedFiles
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const upload_dialog_field_upload_noFiles = (params = {}, options = {}) => {
	return {
		en: en.upload_dialog_field_upload_noFiles,
		ru: ru.upload_dialog_field_upload_noFiles
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const upload_dialog_field_upload_deleteAll = (params = {}, options = {}) => {
	return {
		en: en.upload_dialog_field_upload_deleteAll,
		ru: ru.upload_dialog_field_upload_deleteAll
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const upload_dialog_field_upload_success = (params = {}, options = {}) => {
	return {
		en: en.upload_dialog_field_upload_success,
		ru: ru.upload_dialog_field_upload_success
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const projectCreation_firstProject = (params = {}, options = {}) => {
	return {
		en: en.projectCreation_firstProject,
		ru: ru.projectCreation_firstProject
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const projectCreation_firstDb = (params = {}, options = {}) => {
	return {
		en: en.projectCreation_firstDb,
		ru: ru.projectCreation_firstDb
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const projectCreation_firstProject_title = (params = {}, options = {}) => {
	return {
		en: en.projectCreation_firstProject_title,
		ru: ru.projectCreation_firstProject_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const projectCreation_firstProject_free = (params = {}, options = {}) => {
	return {
		en: en.projectCreation_firstProject_free,
		ru: ru.projectCreation_firstProject_free
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const projectCreation_firstProject_free_desc = (params = {}, options = {}) => {
	return {
		en: en.projectCreation_firstProject_free_desc,
		ru: ru.projectCreation_firstProject_free_desc
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const main_sidebar_title = (params = {}, options = {}) => {
	return {
		en: en.main_sidebar_title,
		ru: ru.main_sidebar_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const main_sidebar_apps = (params = {}, options = {}) => {
	return {
		en: en.main_sidebar_apps,
		ru: ru.main_sidebar_apps
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const main_sidebar_postgres = (params = {}, options = {}) => {
	return {
		en: en.main_sidebar_postgres,
		ru: ru.main_sidebar_postgres
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const main_sidebar_preconfigured = (params = {}, options = {}) => {
	return {
		en: en.main_sidebar_preconfigured,
		ru: ru.main_sidebar_preconfigured
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const main_sidebar_llm = (params = {}, options = {}) => {
	return {
		en: en.main_sidebar_llm,
		ru: ru.main_sidebar_llm
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const main_sidebar_docs = (params = {}, options = {}) => {
	return {
		en: en.main_sidebar_docs,
		ru: ru.main_sidebar_docs
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const secondary_sidebar_header_billing = (params = {}, options = {}) => {
	return {
		en: en.secondary_sidebar_header_billing,
		ru: ru.secondary_sidebar_header_billing
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const secondary_sidebar_info = (params = {}, options = {}) => {
	return {
		en: en.secondary_sidebar_info,
		ru: ru.secondary_sidebar_info
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const secondary_sidebar_repo = (params = {}, options = {}) => {
	return {
		en: en.secondary_sidebar_repo,
		ru: ru.secondary_sidebar_repo
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const secondary_sidebar_dir = (params = {}, options = {}) => {
	return {
		en: en.secondary_sidebar_dir,
		ru: ru.secondary_sidebar_dir
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const secondary_sidebar_config = (params = {}, options = {}) => {
	return {
		en: en.secondary_sidebar_config,
		ru: ru.secondary_sidebar_config
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const secondary_sidebar_logs = (params = {}, options = {}) => {
	return {
		en: en.secondary_sidebar_logs,
		ru: ru.secondary_sidebar_logs
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const secondary_sidebar_envvars = (params = {}, options = {}) => {
	return {
		en: en.secondary_sidebar_envvars,
		ru: ru.secondary_sidebar_envvars
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const secondary_sidebar_domains = (params = {}, options = {}) => {
	return {
		en: en.secondary_sidebar_domains,
		ru: ru.secondary_sidebar_domains
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const secondary_sidebar_backups = (params = {}, options = {}) => {
	return {
		en: en.secondary_sidebar_backups,
		ru: ru.secondary_sidebar_backups
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const secondary_sidebar_subscriptions = (params = {}, options = {}) => {
	return {
		en: en.secondary_sidebar_subscriptions,
		ru: ru.secondary_sidebar_subscriptions
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const secondary_sidebar_alerts = (params = {}, options = {}) => {
	return {
		en: en.secondary_sidebar_alerts,
		ru: ru.secondary_sidebar_alerts
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const secondary_sidebar_settings = (params = {}, options = {}) => {
	return {
		en: en.secondary_sidebar_settings,
		ru: ru.secondary_sidebar_settings
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const secondary_sidebar_logDb = (params = {}, options = {}) => {
	return {
		en: en.secondary_sidebar_logDb,
		ru: ru.secondary_sidebar_logDb
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const secondary_sidebar_details = (params = {}, options = {}) => {
	return {
		en: en.secondary_sidebar_details,
		ru: ru.secondary_sidebar_details
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const secondary_sidebar_balance = (params = {}, options = {}) => {
	return {
		en: en.secondary_sidebar_balance,
		ru: ru.secondary_sidebar_balance
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const secondary_sidebar_legal = (params = {}, options = {}) => {
	return {
		en: en.secondary_sidebar_legal,
		ru: ru.secondary_sidebar_legal
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const breadcrumbs_main = (params = {}, options = {}) => {
	return {
		en: en.breadcrumbs_main,
		ru: ru.breadcrumbs_main
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const breadcrumbs_projects = (params = {}, options = {}) => {
	return {
		en: en.breadcrumbs_projects,
		ru: ru.breadcrumbs_projects
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const breadcrumbs_applications = (params = {}, options = {}) => {
	return {
		en: en.breadcrumbs_applications,
		ru: ru.breadcrumbs_applications
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const breadcrumbs_dbs = (params = {}, options = {}) => {
	return {
		en: en.breadcrumbs_dbs,
		ru: ru.breadcrumbs_dbs
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const breadcrumbs_balance = (params = {}, options = {}) => {
	return {
		en: en.breadcrumbs_balance,
		ru: ru.breadcrumbs_balance
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const breadcrumbs_preConfig = (params = {}, options = {}) => {
	return {
		en: en.breadcrumbs_preConfig,
		ru: ru.breadcrumbs_preConfig
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const breadcrumbs_llm = (params = {}, options = {}) => {
	return {
		en: en.breadcrumbs_llm,
		ru: ru.breadcrumbs_llm
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_title = (params = {}, options = {}) => {
	return {
		en: en.create_dialog_step_title,
		ru: ru.create_dialog_step_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_service = (params = {}, options = {}) => {
	return {
		en: en.create_dialog_step_service,
		ru: ru.create_dialog_step_service
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_tariff = (params = {}, options = {}) => {
	return {
		en: en.create_dialog_step_tariff,
		ru: ru.create_dialog_step_tariff
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_upload = (params = {}, options = {}) => {
	return {
		en: en.create_dialog_step_upload,
		ru: ru.create_dialog_step_upload
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_config = (params = {}, options = {}) => {
	return {
		en: en.create_dialog_step_config,
		ru: ru.create_dialog_step_config
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_variables = (params = {}, options = {}) => {
	return {
		en: en.create_dialog_step_variables,
		ru: ru.create_dialog_step_variables
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_next_btn = (params = {}, options = {}) => {
	return {
		en: en.create_dialog_step_next_btn,
		ru: ru.create_dialog_step_next_btn
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_back_btn = (params = {}, options = {}) => {
	return {
		en: en.create_dialog_step_back_btn,
		ru: ru.create_dialog_step_back_btn
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_fin_btn = (params = {}, options = {}) => {
	return {
		en: en.create_dialog_step_fin_btn,
		ru: ru.create_dialog_step_fin_btn
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_gitDialog_desc = (params = {}, options = {}) => {
	return {
		en: en.create_dialog_step_gitDialog_desc,
		ru: ru.create_dialog_step_gitDialog_desc
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_gitDialog_confirm = (params = {}, options = {}) => {
	return {
		en: en.create_dialog_step_gitDialog_confirm,
		ru: ru.create_dialog_step_gitDialog_confirm
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_service_serviceType = (params = {}, options = {}) => {
	return {
		en: en.create_dialog_step_service_serviceType,
		ru: ru.create_dialog_step_service_serviceType
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_service_serviceType_placeholder = (params = {}, options = {}) => {
	return {
		en: en.create_dialog_step_service_serviceType_placeholder,
		ru: ru.create_dialog_step_service_serviceType_placeholder
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_service_projectType = (params = {}, options = {}) => {
	return {
		en: en.create_dialog_step_service_projectType,
		ru: ru.create_dialog_step_service_projectType
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_service_projectType_placeholder = (params = {}, options = {}) => {
	return {
		en: en.create_dialog_step_service_projectType_placeholder,
		ru: ru.create_dialog_step_service_projectType_placeholder
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_service_marketType = (params = {}, options = {}) => {
	return {
		en: en.create_dialog_step_service_marketType,
		ru: ru.create_dialog_step_service_marketType
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_service_marketType_placeholder = (params = {}, options = {}) => {
	return {
		en: en.create_dialog_step_service_marketType_placeholder,
		ru: ru.create_dialog_step_service_marketType_placeholder
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_service_serviceTypes_app = (params = {}, options = {}) => {
	return {
		en: en.create_dialog_step_service_serviceTypes_app,
		ru: ru.create_dialog_step_service_serviceTypes_app
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_service_serviceTypes_db = (params = {}, options = {}) => {
	return {
		en: en.create_dialog_step_service_serviceTypes_db,
		ru: ru.create_dialog_step_service_serviceTypes_db
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_service_serviceTypes_marketplace = (params = {}, options = {}) => {
	return {
		en: en.create_dialog_step_service_serviceTypes_marketplace,
		ru: ru.create_dialog_step_service_serviceTypes_marketplace
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_service_marketPlaceLables_mq = (params = {}, options = {}) => {
	return {
		en: en.create_dialog_step_service_marketPlaceLables_mq,
		ru: ru.create_dialog_step_service_marketPlaceLables_mq
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_service_marketPlaceLables_db = (params = {}, options = {}) => {
	return {
		en: en.create_dialog_step_service_marketPlaceLables_db,
		ru: ru.create_dialog_step_service_marketPlaceLables_db
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_service_marketPlaceLables_authorization = (params = {}, options = {}) => {
	return {
		en: en.create_dialog_step_service_marketPlaceLables_authorization,
		ru: ru.create_dialog_step_service_marketPlaceLables_authorization
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_service_marketPlaceLables_bi = (params = {}, options = {}) => {
	return {
		en: en.create_dialog_step_service_marketPlaceLables_bi,
		ru: ru.create_dialog_step_service_marketPlaceLables_bi
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_service_marketPlaceLables_db_utils = (params = {}, options = {}) => {
	return {
		en: en.create_dialog_step_service_marketPlaceLables_db_utils,
		ru: ru.create_dialog_step_service_marketPlaceLables_db_utils
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_service_marketPlaceLables_db_mail_and_notifications = (params = {}, options = {}) => {
	return {
		en: en.create_dialog_step_service_marketPlaceLables_db_mail_and_notifications,
		ru: ru.create_dialog_step_service_marketPlaceLables_db_mail_and_notifications
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_service_marketPlaceLables_ai = (params = {}, options = {}) => {
	return {
		en: en.create_dialog_step_service_marketPlaceLables_ai,
		ru: ru.create_dialog_step_service_marketPlaceLables_ai
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_tariff_projectName = (params = {}, options = {}) => {
	return {
		en: en.create_dialog_step_tariff_projectName,
		ru: ru.create_dialog_step_tariff_projectName
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_tariff_projectName_placeholder = (params = {}, options = {}) => {
	return {
		en: en.create_dialog_step_tariff_projectName_placeholder,
		ru: ru.create_dialog_step_tariff_projectName_placeholder
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_tariff_projectName_symbolErrors = (params = {}, options = {}) => {
	return {
		en: en.create_dialog_step_tariff_projectName_symbolErrors,
		ru: ru.create_dialog_step_tariff_projectName_symbolErrors
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ maxLength: NonNullable<unknown> }} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_tariff_projectName_lengthError = (params , options = {}) => {
	return {
		en: en.create_dialog_step_tariff_projectName_lengthError,
		ru: ru.create_dialog_step_tariff_projectName_lengthError
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_tariff_projectName_noNew = (params = {}, options = {}) => {
	return {
		en: en.create_dialog_step_tariff_projectName_noNew,
		ru: ru.create_dialog_step_tariff_projectName_noNew
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_tariff_plan_alert = (params = {}, options = {}) => {
	return {
		en: en.create_dialog_step_tariff_plan_alert,
		ru: ru.create_dialog_step_tariff_plan_alert
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_tariff_plan = (params = {}, options = {}) => {
	return {
		en: en.create_dialog_step_tariff_plan,
		ru: ru.create_dialog_step_tariff_plan
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_tariff_renewal_checkbox = (params = {}, options = {}) => {
	return {
		en: en.create_dialog_step_tariff_renewal_checkbox,
		ru: ru.create_dialog_step_tariff_renewal_checkbox
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_tariff_autoRenewal = (params = {}, options = {}) => {
	return {
		en: en.create_dialog_step_tariff_autoRenewal,
		ru: ru.create_dialog_step_tariff_autoRenewal
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_tariff_maxAutoRenewals = (params = {}, options = {}) => {
	return {
		en: en.create_dialog_step_tariff_maxAutoRenewals,
		ru: ru.create_dialog_step_tariff_maxAutoRenewals
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_tariff_plan_db = (params = {}, options = {}) => {
	return {
		en: en.create_dialog_step_tariff_plan_db,
		ru: ru.create_dialog_step_tariff_plan_db
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_upload_gitOption = (params = {}, options = {}) => {
	return {
		en: en.create_dialog_step_upload_gitOption,
		ru: ru.create_dialog_step_upload_gitOption
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_upload_gitOption_hint = (params = {}, options = {}) => {
	return {
		en: en.create_dialog_step_upload_gitOption_hint,
		ru: ru.create_dialog_step_upload_gitOption_hint
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_upload_interfaceOption = (params = {}, options = {}) => {
	return {
		en: en.create_dialog_step_upload_interfaceOption,
		ru: ru.create_dialog_step_upload_interfaceOption
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_upload_interfaceOption_hint_start = (params = {}, options = {}) => {
	return {
		en: en.create_dialog_step_upload_interfaceOption_hint_start,
		ru: ru.create_dialog_step_upload_interfaceOption_hint_start
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_upload_interfaceOption_hint_link = (params = {}, options = {}) => {
	return {
		en: en.create_dialog_step_upload_interfaceOption_hint_link,
		ru: ru.create_dialog_step_upload_interfaceOption_hint_link
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_upload_interfaceOption_hint_end = (params = {}, options = {}) => {
	return {
		en: en.create_dialog_step_upload_interfaceOption_hint_end,
		ru: ru.create_dialog_step_upload_interfaceOption_hint_end
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_config_alert = (params = {}, options = {}) => {
	return {
		en: en.create_dialog_step_config_alert,
		ru: ru.create_dialog_step_config_alert
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_config_title = (params = {}, options = {}) => {
	return {
		en: en.create_dialog_step_config_title,
		ru: ru.create_dialog_step_config_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_config_downloadConfig = (params = {}, options = {}) => {
	return {
		en: en.create_dialog_step_config_downloadConfig,
		ru: ru.create_dialog_step_config_downloadConfig
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_error_409 = (params = {}, options = {}) => {
	return {
		en: en.create_dialog_step_error_409,
		ru: ru.create_dialog_step_error_409
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_error_500 = (params = {}, options = {}) => {
	return {
		en: en.create_dialog_step_error_500,
		ru: ru.create_dialog_step_error_500
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const main_page_title = (params = {}, options = {}) => {
	return {
		en: en.main_page_title,
		ru: ru.main_page_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const main_page_card_app = (params = {}, options = {}) => {
	return {
		en: en.main_page_card_app,
		ru: ru.main_page_card_app
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const main_page_card_db = (params = {}, options = {}) => {
	return {
		en: en.main_page_card_db,
		ru: ru.main_page_card_db
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const main_page_card_preconfigured = (params = {}, options = {}) => {
	return {
		en: en.main_page_card_preconfigured,
		ru: ru.main_page_card_preconfigured
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const main_page_card_llm = (params = {}, options = {}) => {
	return {
		en: en.main_page_card_llm,
		ru: ru.main_page_card_llm
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const main_page_card_total = (params = {}, options = {}) => {
	return {
		en: en.main_page_card_total,
		ru: ru.main_page_card_total
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const main_page_card_running = (params = {}, options = {}) => {
	return {
		en: en.main_page_card_running,
		ru: ru.main_page_card_running
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const main_page_card_clutster = (params = {}, options = {}) => {
	return {
		en: en.main_page_card_clutster,
		ru: ru.main_page_card_clutster
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const main_page_card_inference_models = (params = {}, options = {}) => {
	return {
		en: en.main_page_card_inference_models,
		ru: ru.main_page_card_inference_models
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const main_page_createBtn = (params = {}, options = {}) => {
	return {
		en: en.main_page_createBtn,
		ru: ru.main_page_createBtn
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const main_page_services = (params = {}, options = {}) => {
	return {
		en: en.main_page_services,
		ru: ru.main_page_services
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const db_main_page_title = (params = {}, options = {}) => {
	return {
		en: en.db_main_page_title,
		ru: ru.db_main_page_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const db_main_page_table_column_name = (params = {}, options = {}) => {
	return {
		en: en.db_main_page_table_column_name,
		ru: ru.db_main_page_table_column_name
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const db_main_page_table_column_type = (params = {}, options = {}) => {
	return {
		en: en.db_main_page_table_column_type,
		ru: ru.db_main_page_table_column_type
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const db_main_page_table_filter = (params = {}, options = {}) => {
	return {
		en: en.db_main_page_table_filter,
		ru: ru.db_main_page_table_filter
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const app_main_page_btn = (params = {}, options = {}) => {
	return {
		en: en.app_main_page_btn,
		ru: ru.app_main_page_btn
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const llm_main_page_btn = (params = {}, options = {}) => {
	return {
		en: en.llm_main_page_btn,
		ru: ru.llm_main_page_btn
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const preConfig_main_page_title = (params = {}, options = {}) => {
	return {
		en: en.preConfig_main_page_title,
		ru: ru.preConfig_main_page_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const preConfig_main_page_btn = (params = {}, options = {}) => {
	return {
		en: en.preConfig_main_page_btn,
		ru: ru.preConfig_main_page_btn
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const resource_status_NONE = (params = {}, options = {}) => {
	return {
		en: en.resource_status_NONE,
		ru: ru.resource_status_NONE
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const resource_status_NO_DATA = (params = {}, options = {}) => {
	return {
		en: en.resource_status_NO_DATA,
		ru: ru.resource_status_NO_DATA
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const resource_status_RED = (params = {}, options = {}) => {
	return {
		en: en.resource_status_RED,
		ru: ru.resource_status_RED
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const resource_status_YELLOW = (params = {}, options = {}) => {
	return {
		en: en.resource_status_YELLOW,
		ru: ru.resource_status_YELLOW
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const resource_status_GREEN = (params = {}, options = {}) => {
	return {
		en: en.resource_status_GREEN,
		ru: ru.resource_status_GREEN
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_ctrl_btns_replicas = (params = {}, options = {}) => {
	return {
		en: en.project_ctrl_btns_replicas,
		ru: ru.project_ctrl_btns_replicas
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_ctrl_btns_replicas_tooltip_cur = (params = {}, options = {}) => {
	return {
		en: en.project_ctrl_btns_replicas_tooltip_cur,
		ru: ru.project_ctrl_btns_replicas_tooltip_cur
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_ctrl_btns_replicas_tooltip_req = (params = {}, options = {}) => {
	return {
		en: en.project_ctrl_btns_replicas_tooltip_req,
		ru: ru.project_ctrl_btns_replicas_tooltip_req
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_ctrl_btns_start = (params = {}, options = {}) => {
	return {
		en: en.project_ctrl_btns_start,
		ru: ru.project_ctrl_btns_start
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_ctrl_btns_stop = (params = {}, options = {}) => {
	return {
		en: en.project_ctrl_btns_stop,
		ru: ru.project_ctrl_btns_stop
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_ctrl_btns_rebuild = (params = {}, options = {}) => {
	return {
		en: en.project_ctrl_btns_rebuild,
		ru: ru.project_ctrl_btns_rebuild
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_ctrl_btns_rerun = (params = {}, options = {}) => {
	return {
		en: en.project_ctrl_btns_rerun,
		ru: ru.project_ctrl_btns_rerun
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_ctrl_btns_project = (params = {}, options = {}) => {
	return {
		en: en.project_ctrl_btns_project,
		ru: ru.project_ctrl_btns_project
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_balance_title = (params = {}, options = {}) => {
	return {
		en: en.billing_tab_balance_title,
		ru: ru.billing_tab_balance_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_balance_topup = (params = {}, options = {}) => {
	return {
		en: en.billing_tab_balance_topup,
		ru: ru.billing_tab_balance_topup
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_balance_limit = (params = {}, options = {}) => {
	return {
		en: en.billing_tab_balance_limit,
		ru: ru.billing_tab_balance_limit
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_balance_limit_tooltip = (params = {}, options = {}) => {
	return {
		en: en.billing_tab_balance_limit_tooltip,
		ru: ru.billing_tab_balance_limit_tooltip
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_balance_autoPay = (params = {}, options = {}) => {
	return {
		en: en.billing_tab_balance_autoPay,
		ru: ru.billing_tab_balance_autoPay
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_balance_addFunds = (params = {}, options = {}) => {
	return {
		en: en.billing_tab_balance_addFunds,
		ru: ru.billing_tab_balance_addFunds
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_balance_promoCode = (params = {}, options = {}) => {
	return {
		en: en.billing_tab_balance_promoCode,
		ru: ru.billing_tab_balance_promoCode
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_usedPromocodes = (params = {}, options = {}) => {
	return {
		en: en.billing_tab_usedPromocodes,
		ru: ru.billing_tab_usedPromocodes
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_balance_promoCode_placeholder = (params = {}, options = {}) => {
	return {
		en: en.billing_tab_balance_promoCode_placeholder,
		ru: ru.billing_tab_balance_promoCode_placeholder
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_promo_200 = (params = {}, options = {}) => {
	return {
		en: en.billing_tab_promo_200,
		ru: ru.billing_tab_promo_200
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_promo_404 = (params = {}, options = {}) => {
	return {
		en: en.billing_tab_promo_404,
		ru: ru.billing_tab_promo_404
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_promo_406 = (params = {}, options = {}) => {
	return {
		en: en.billing_tab_promo_406,
		ru: ru.billing_tab_promo_406
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_promo_409 = (params = {}, options = {}) => {
	return {
		en: en.billing_tab_promo_409,
		ru: ru.billing_tab_promo_409
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_promo_500 = (params = {}, options = {}) => {
	return {
		en: en.billing_tab_promo_500,
		ru: ru.billing_tab_promo_500
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_promo_501 = (params = {}, options = {}) => {
	return {
		en: en.billing_tab_promo_501,
		ru: ru.billing_tab_promo_501
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_recurrent_delete_success_snack = (params = {}, options = {}) => {
	return {
		en: en.billing_tab_recurrent_delete_success_snack,
		ru: ru.billing_tab_recurrent_delete_success_snack
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_recurrent_amount = (params = {}, options = {}) => {
	return {
		en: en.billing_tab_recurrent_amount,
		ru: ru.billing_tab_recurrent_amount
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_recurrent_max_amount = (params = {}, options = {}) => {
	return {
		en: en.billing_tab_recurrent_max_amount,
		ru: ru.billing_tab_recurrent_max_amount
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_details_req = (params = {}, options = {}) => {
	return {
		en: en.billing_tab_legal_details_req,
		ru: ru.billing_tab_legal_details_req
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_closingDocs = (params = {}, options = {}) => {
	return {
		en: en.billing_tab_legal_closingDocs,
		ru: ru.billing_tab_legal_closingDocs
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_invoice = (params = {}, options = {}) => {
	return {
		en: en.billing_tab_legal_invoice,
		ru: ru.billing_tab_legal_invoice
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_field_shortName = (params = {}, options = {}) => {
	return {
		en: en.billing_tab_legal_field_shortName,
		ru: ru.billing_tab_legal_field_shortName
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_field_fullName = (params = {}, options = {}) => {
	return {
		en: en.billing_tab_legal_field_fullName,
		ru: ru.billing_tab_legal_field_fullName
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_field_tin = (params = {}, options = {}) => {
	return {
		en: en.billing_tab_legal_field_tin,
		ru: ru.billing_tab_legal_field_tin
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_field_kpp = (params = {}, options = {}) => {
	return {
		en: en.billing_tab_legal_field_kpp,
		ru: ru.billing_tab_legal_field_kpp
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_field_ogrn = (params = {}, options = {}) => {
	return {
		en: en.billing_tab_legal_field_ogrn,
		ru: ru.billing_tab_legal_field_ogrn
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_field_beneficiaryAccount = (params = {}, options = {}) => {
	return {
		en: en.billing_tab_legal_field_beneficiaryAccount,
		ru: ru.billing_tab_legal_field_beneficiaryAccount
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_field_bic = (params = {}, options = {}) => {
	return {
		en: en.billing_tab_legal_field_bic,
		ru: ru.billing_tab_legal_field_bic
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_field_additionalMail = (params = {}, options = {}) => {
	return {
		en: en.billing_tab_legal_field_additionalMail,
		ru: ru.billing_tab_legal_field_additionalMail
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_field_additionalMail_emailError = (params = {}, options = {}) => {
	return {
		en: en.billing_tab_legal_field_additionalMail_emailError,
		ru: ru.billing_tab_legal_field_additionalMail_emailError
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_field_additionalPhoneNumber = (params = {}, options = {}) => {
	return {
		en: en.billing_tab_legal_field_additionalPhoneNumber,
		ru: ru.billing_tab_legal_field_additionalPhoneNumber
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_field_additionalPhoneNumber_numberError = (params = {}, options = {}) => {
	return {
		en: en.billing_tab_legal_field_additionalPhoneNumber_numberError,
		ru: ru.billing_tab_legal_field_additionalPhoneNumber_numberError
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_field_amount_error = (params = {}, options = {}) => {
	return {
		en: en.billing_tab_legal_field_amount_error,
		ru: ru.billing_tab_legal_field_amount_error
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_closingDocs_docType = (params = {}, options = {}) => {
	return {
		en: en.billing_tab_legal_closingDocs_docType,
		ru: ru.billing_tab_legal_closingDocs_docType
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_closingDocs_docType_BILL = (params = {}, options = {}) => {
	return {
		en: en.billing_tab_legal_closingDocs_docType_BILL,
		ru: ru.billing_tab_legal_closingDocs_docType_BILL
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_closingDocs_docType_INVOICE = (params = {}, options = {}) => {
	return {
		en: en.billing_tab_legal_closingDocs_docType_INVOICE,
		ru: ru.billing_tab_legal_closingDocs_docType_INVOICE
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_closingDocs_docType_RECONCILIATION_REPORT = (params = {}, options = {}) => {
	return {
		en: en.billing_tab_legal_closingDocs_docType_RECONCILIATION_REPORT,
		ru: ru.billing_tab_legal_closingDocs_docType_RECONCILIATION_REPORT
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_closingDocs_date = (params = {}, options = {}) => {
	return {
		en: en.billing_tab_legal_closingDocs_date,
		ru: ru.billing_tab_legal_closingDocs_date
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_closingDocs_time = (params = {}, options = {}) => {
	return {
		en: en.billing_tab_legal_closingDocs_time,
		ru: ru.billing_tab_legal_closingDocs_time
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_invoice_warn = (params = {}, options = {}) => {
	return {
		en: en.billing_tab_legal_invoice_warn,
		ru: ru.billing_tab_legal_invoice_warn
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_invoice_btn_issue = (params = {}, options = {}) => {
	return {
		en: en.billing_tab_legal_invoice_btn_issue,
		ru: ru.billing_tab_legal_invoice_btn_issue
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_invoice_table_date = (params = {}, options = {}) => {
	return {
		en: en.billing_tab_legal_invoice_table_date,
		ru: ru.billing_tab_legal_invoice_table_date
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_invoice_table_status = (params = {}, options = {}) => {
	return {
		en: en.billing_tab_legal_invoice_table_status,
		ru: ru.billing_tab_legal_invoice_table_status
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_invoice_table_amount = (params = {}, options = {}) => {
	return {
		en: en.billing_tab_legal_invoice_table_amount,
		ru: ru.billing_tab_legal_invoice_table_amount
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_invoice_table_sendEmail = (params = {}, options = {}) => {
	return {
		en: en.billing_tab_legal_invoice_table_sendEmail,
		ru: ru.billing_tab_legal_invoice_table_sendEmail
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_invoice_sendEmail_200 = (params = {}, options = {}) => {
	return {
		en: en.billing_tab_legal_invoice_sendEmail_200,
		ru: ru.billing_tab_legal_invoice_sendEmail_200
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_invoice_emailTitle = (params = {}, options = {}) => {
	return {
		en: en.billing_tab_legal_invoice_emailTitle,
		ru: ru.billing_tab_legal_invoice_emailTitle
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_invoice_emailInfo = (params = {}, options = {}) => {
	return {
		en: en.billing_tab_legal_invoice_emailInfo,
		ru: ru.billing_tab_legal_invoice_emailInfo
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_invoice_orDiffEmail = (params = {}, options = {}) => {
	return {
		en: en.billing_tab_legal_invoice_orDiffEmail,
		ru: ru.billing_tab_legal_invoice_orDiffEmail
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_balance_history = (params = {}, options = {}) => {
	return {
		en: en.billing_tab_balance_history,
		ru: ru.billing_tab_balance_history
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_balance_writeOffs = (params = {}, options = {}) => {
	return {
		en: en.billing_tab_balance_writeOffs,
		ru: ru.billing_tab_balance_writeOffs
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_balance_credits = (params = {}, options = {}) => {
	return {
		en: en.billing_tab_balance_credits,
		ru: ru.billing_tab_balance_credits
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_balance_serviceType = (params = {}, options = {}) => {
	return {
		en: en.billing_tab_balance_serviceType,
		ru: ru.billing_tab_balance_serviceType
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_balance_service = (params = {}, options = {}) => {
	return {
		en: en.billing_tab_balance_service,
		ru: ru.billing_tab_balance_service
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_balance_plan = (params = {}, options = {}) => {
	return {
		en: en.billing_tab_balance_plan,
		ru: ru.billing_tab_balance_plan
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_balance_productName = (params = {}, options = {}) => {
	return {
		en: en.billing_tab_balance_productName,
		ru: ru.billing_tab_balance_productName
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_balance_units = (params = {}, options = {}) => {
	return {
		en: en.billing_tab_balance_units,
		ru: ru.billing_tab_balance_units
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_balance_price = (params = {}, options = {}) => {
	return {
		en: en.billing_tab_balance_price,
		ru: ru.billing_tab_balance_price
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_balance_amount = (params = {}, options = {}) => {
	return {
		en: en.billing_tab_balance_amount,
		ru: ru.billing_tab_balance_amount
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_balance_from = (params = {}, options = {}) => {
	return {
		en: en.billing_tab_balance_from,
		ru: ru.billing_tab_balance_from
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_balance_to = (params = {}, options = {}) => {
	return {
		en: en.billing_tab_balance_to,
		ru: ru.billing_tab_balance_to
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_balance_amount2 = (params = {}, options = {}) => {
	return {
		en: en.billing_tab_balance_amount2,
		ru: ru.billing_tab_balance_amount2
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_balance_paymentType = (params = {}, options = {}) => {
	return {
		en: en.billing_tab_balance_paymentType,
		ru: ru.billing_tab_balance_paymentType
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_balance_currency = (params = {}, options = {}) => {
	return {
		en: en.billing_tab_balance_currency,
		ru: ru.billing_tab_balance_currency
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_balance_date = (params = {}, options = {}) => {
	return {
		en: en.billing_tab_balance_date,
		ru: ru.billing_tab_balance_date
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_balance_manual = (params = {}, options = {}) => {
	return {
		en: en.billing_tab_balance_manual,
		ru: ru.billing_tab_balance_manual
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_balance_autoPayment = (params = {}, options = {}) => {
	return {
		en: en.billing_tab_balance_autoPayment,
		ru: ru.billing_tab_balance_autoPayment
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tabs_info_examplesHelper = (params = {}, options = {}) => {
	return {
		en: en.tabs_info_examplesHelper,
		ru: ru.tabs_info_examplesHelper
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tabs_info_herokuHelper = (params = {}, options = {}) => {
	return {
		en: en.tabs_info_herokuHelper,
		ru: ru.tabs_info_herokuHelper
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tabs_info_configHeader = (params = {}, options = {}) => {
	return {
		en: en.tabs_info_configHeader,
		ru: ru.tabs_info_configHeader
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ docDomain: NonNullable<unknown> }} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tabs_info_configDescription = (params , options = {}) => {
	return {
		en: en.tabs_info_configDescription,
		ru: ru.tabs_info_configDescription
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tabs_info_deployHeader = (params = {}, options = {}) => {
	return {
		en: en.tabs_info_deployHeader,
		ru: ru.tabs_info_deployHeader
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tabs_info_deployDescription = (params = {}, options = {}) => {
	return {
		en: en.tabs_info_deployDescription,
		ru: ru.tabs_info_deployDescription
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tabs_info_deployOptionsHeader = (params = {}, options = {}) => {
	return {
		en: en.tabs_info_deployOptionsHeader,
		ru: ru.tabs_info_deployOptionsHeader
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ docDomain: NonNullable<unknown> }} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tabs_info_deployOptionsLi1 = (params , options = {}) => {
	return {
		en: en.tabs_info_deployOptionsLi1,
		ru: ru.tabs_info_deployOptionsLi1
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tabs_info_deploymentOptionsLi2 = (params = {}, options = {}) => {
	return {
		en: en.tabs_info_deploymentOptionsLi2,
		ru: ru.tabs_info_deploymentOptionsLi2
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tabs_info_deploymentOptionsLi3 = (params = {}, options = {}) => {
	return {
		en: en.tabs_info_deploymentOptionsLi3,
		ru: ru.tabs_info_deploymentOptionsLi3
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tabs_info_domainHeader = (params = {}, options = {}) => {
	return {
		en: en.tabs_info_domainHeader,
		ru: ru.tabs_info_domainHeader
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tabs_info_domainDescription = (params = {}, options = {}) => {
	return {
		en: en.tabs_info_domainDescription,
		ru: ru.tabs_info_domainDescription
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tabs_info_domainOptionsLi1 = (params = {}, options = {}) => {
	return {
		en: en.tabs_info_domainOptionsLi1,
		ru: ru.tabs_info_domainOptionsLi1
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tabs_info_domainOptionsLi1_caption = (params = {}, options = {}) => {
	return {
		en: en.tabs_info_domainOptionsLi1_caption,
		ru: ru.tabs_info_domainOptionsLi1_caption
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tabs_info_domainOptionsLi2 = (params = {}, options = {}) => {
	return {
		en: en.tabs_info_domainOptionsLi2,
		ru: ru.tabs_info_domainOptionsLi2
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ serviceType: NonNullable<unknown> }} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tabs_info_marketplace_title = (params , options = {}) => {
	return {
		en: en.tabs_info_marketplace_title,
		ru: ru.tabs_info_marketplace_title
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tabs_info_marketplace_description = (params = {}, options = {}) => {
	return {
		en: en.tabs_info_marketplace_description,
		ru: ru.tabs_info_marketplace_description
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tabs_info_marketplace_externalDomain = (params = {}, options = {}) => {
	return {
		en: en.tabs_info_marketplace_externalDomain,
		ru: ru.tabs_info_marketplace_externalDomain
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbInfo_connectHelper = (params = {}, options = {}) => {
	return {
		en: en.tab_dbInfo_connectHelper,
		ru: ru.tab_dbInfo_connectHelper
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbInfo_pgAdmin = (params = {}, options = {}) => {
	return {
		en: en.tab_dbInfo_pgAdmin,
		ru: ru.tab_dbInfo_pgAdmin
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbInfo_domainTitle = (params = {}, options = {}) => {
	return {
		en: en.tab_dbInfo_domainTitle,
		ru: ru.tab_dbInfo_domainTitle
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbInfo_domainRwOption = (params = {}, options = {}) => {
	return {
		en: en.tab_dbInfo_domainRwOption,
		ru: ru.tab_dbInfo_domainRwOption
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbInfo_domainRoOption = (params = {}, options = {}) => {
	return {
		en: en.tab_dbInfo_domainRoOption,
		ru: ru.tab_dbInfo_domainRoOption
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbInfo_domainROption = (params = {}, options = {}) => {
	return {
		en: en.tab_dbInfo_domainROption,
		ru: ru.tab_dbInfo_domainROption
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbConfig_version_hint = (params = {}, options = {}) => {
	return {
		en: en.tab_dbConfig_version_hint,
		ru: ru.tab_dbConfig_version_hint
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbConfig_dbName = (params = {}, options = {}) => {
	return {
		en: en.tab_dbConfig_dbName,
		ru: ru.tab_dbConfig_dbName
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbConfig_dbName_placeholder = (params = {}, options = {}) => {
	return {
		en: en.tab_dbConfig_dbName_placeholder,
		ru: ru.tab_dbConfig_dbName_placeholder
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbConfig_dbName_hint = (params = {}, options = {}) => {
	return {
		en: en.tab_dbConfig_dbName_hint,
		ru: ru.tab_dbConfig_dbName_hint
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbConfig_dbUsername = (params = {}, options = {}) => {
	return {
		en: en.tab_dbConfig_dbUsername,
		ru: ru.tab_dbConfig_dbUsername
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbConfig_dbUsername_placeholder = (params = {}, options = {}) => {
	return {
		en: en.tab_dbConfig_dbUsername_placeholder,
		ru: ru.tab_dbConfig_dbUsername_placeholder
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbConfig_dbUsername_hint = (params = {}, options = {}) => {
	return {
		en: en.tab_dbConfig_dbUsername_hint,
		ru: ru.tab_dbConfig_dbUsername_hint
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbConfig_dbPassword = (params = {}, options = {}) => {
	return {
		en: en.tab_dbConfig_dbPassword,
		ru: ru.tab_dbConfig_dbPassword
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbConfig_dbPassword_placeholder = (params = {}, options = {}) => {
	return {
		en: en.tab_dbConfig_dbPassword_placeholder,
		ru: ru.tab_dbConfig_dbPassword_placeholder
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbConfig_dbPassword_hint = (params = {}, options = {}) => {
	return {
		en: en.tab_dbConfig_dbPassword_hint,
		ru: ru.tab_dbConfig_dbPassword_hint
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbConfig_instances = (params = {}, options = {}) => {
	return {
		en: en.tab_dbConfig_instances,
		ru: ru.tab_dbConfig_instances
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbConfig_instances_placeholder = (params = {}, options = {}) => {
	return {
		en: en.tab_dbConfig_instances_placeholder,
		ru: ru.tab_dbConfig_instances_placeholder
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbConfig_instances_hint = (params = {}, options = {}) => {
	return {
		en: en.tab_dbConfig_instances_hint,
		ru: ru.tab_dbConfig_instances_hint
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbConfig_superuser = (params = {}, options = {}) => {
	return {
		en: en.tab_dbConfig_superuser,
		ru: ru.tab_dbConfig_superuser
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbConfig_superuser_hint = (params = {}, options = {}) => {
	return {
		en: en.tab_dbConfig_superuser_hint,
		ru: ru.tab_dbConfig_superuser_hint
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbConfig_superuserPassword = (params = {}, options = {}) => {
	return {
		en: en.tab_dbConfig_superuserPassword,
		ru: ru.tab_dbConfig_superuserPassword
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbConfig_superuserPassword_placeholder = (params = {}, options = {}) => {
	return {
		en: en.tab_dbConfig_superuserPassword_placeholder,
		ru: ru.tab_dbConfig_superuserPassword_placeholder
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbConfig_superuserPassword_hint = (params = {}, options = {}) => {
	return {
		en: en.tab_dbConfig_superuserPassword_hint,
		ru: ru.tab_dbConfig_superuserPassword_hint
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbBackups_alert_backups = (params = {}, options = {}) => {
	return {
		en: en.tab_dbBackups_alert_backups,
		ru: ru.tab_dbBackups_alert_backups
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbBackups_alert_restoreBackups = (params = {}, options = {}) => {
	return {
		en: en.tab_dbBackups_alert_restoreBackups,
		ru: ru.tab_dbBackups_alert_restoreBackups
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbBackups_activateDaily = (params = {}, options = {}) => {
	return {
		en: en.tab_dbBackups_activateDaily,
		ru: ru.tab_dbBackups_activateDaily
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbBackups_instant = (params = {}, options = {}) => {
	return {
		en: en.tab_dbBackups_instant,
		ru: ru.tab_dbBackups_instant
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbBackups_empty = (params = {}, options = {}) => {
	return {
		en: en.tab_dbBackups_empty,
		ru: ru.tab_dbBackups_empty
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbBackups_create = (params = {}, options = {}) => {
	return {
		en: en.tab_dbBackups_create,
		ru: ru.tab_dbBackups_create
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbBackups_dialog_tilte = (params = {}, options = {}) => {
	return {
		en: en.tab_dbBackups_dialog_tilte,
		ru: ru.tab_dbBackups_dialog_tilte
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbBackups_dialog_create_success = (params = {}, options = {}) => {
	return {
		en: en.tab_dbBackups_dialog_create_success,
		ru: ru.tab_dbBackups_dialog_create_success
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbBackups_dialog_restore_errorName = (params = {}, options = {}) => {
	return {
		en: en.tab_dbBackups_dialog_restore_errorName,
		ru: ru.tab_dbBackups_dialog_restore_errorName
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbBackups_dialog_restore_maxLengthErorr = (params = {}, options = {}) => {
	return {
		en: en.tab_dbBackups_dialog_restore_maxLengthErorr,
		ru: ru.tab_dbBackups_dialog_restore_maxLengthErorr
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_upload_btn = (params = {}, options = {}) => {
	return {
		en: en.tab_repo_upload_btn,
		ru: ru.tab_repo_upload_btn
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_download_btn = (params = {}, options = {}) => {
	return {
		en: en.tab_repo_download_btn,
		ru: ru.tab_repo_download_btn
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_download_selection = (params = {}, options = {}) => {
	return {
		en: en.tab_repo_download_selection,
		ru: ru.tab_repo_download_selection
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_download_storage = (params = {}, options = {}) => {
	return {
		en: en.tab_repo_download_storage,
		ru: ru.tab_repo_download_storage
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_download_code = (params = {}, options = {}) => {
	return {
		en: en.tab_repo_download_code,
		ru: ru.tab_repo_download_code
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_download_artifacts = (params = {}, options = {}) => {
	return {
		en: en.tab_repo_download_artifacts,
		ru: ru.tab_repo_download_artifacts
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_download_repo = (params = {}, options = {}) => {
	return {
		en: en.tab_repo_download_repo,
		ru: ru.tab_repo_download_repo
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_folder = (params = {}, options = {}) => {
	return {
		en: en.tab_repo_folder,
		ru: ru.tab_repo_folder
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_folder_empty = (params = {}, options = {}) => {
	return {
		en: en.tab_repo_folder_empty,
		ru: ru.tab_repo_folder_empty
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_folder_init = (params = {}, options = {}) => {
	return {
		en: en.tab_repo_folder_init,
		ru: ru.tab_repo_folder_init
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_gitTitle_v2 = (params = {}, options = {}) => {
	return {
		en: en.tab_repo_gitTitle_v2,
		ru: ru.tab_repo_gitTitle_v2
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_gitTitle = (params = {}, options = {}) => {
	return {
		en: en.tab_repo_gitTitle,
		ru: ru.tab_repo_gitTitle
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_event = (params = {}, options = {}) => {
	return {
		en: en.tab_repo_event,
		ru: ru.tab_repo_event
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_event_hint = (params = {}, options = {}) => {
	return {
		en: en.tab_repo_event_hint,
		ru: ru.tab_repo_event_hint
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_url_hint = (params = {}, options = {}) => {
	return {
		en: en.tab_repo_url_hint,
		ru: ru.tab_repo_url_hint
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_secret = (params = {}, options = {}) => {
	return {
		en: en.tab_repo_secret,
		ru: ru.tab_repo_secret
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_secret_error = (params = {}, options = {}) => {
	return {
		en: en.tab_repo_secret_error,
		ru: ru.tab_repo_secret_error
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_token = (params = {}, options = {}) => {
	return {
		en: en.tab_repo_token,
		ru: ru.tab_repo_token
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_remoteRepo = (params = {}, options = {}) => {
	return {
		en: en.tab_repo_remoteRepo,
		ru: ru.tab_repo_remoteRepo
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_remoteBranch = (params = {}, options = {}) => {
	return {
		en: en.tab_repo_remoteBranch,
		ru: ru.tab_repo_remoteBranch
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_remoteBranch_hint = (params = {}, options = {}) => {
	return {
		en: en.tab_repo_remoteBranch_hint,
		ru: ru.tab_repo_remoteBranch_hint
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_connect_btn = (params = {}, options = {}) => {
	return {
		en: en.tab_repo_connect_btn,
		ru: ru.tab_repo_connect_btn
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_connect_first_success = (params = {}, options = {}) => {
	return {
		en: en.tab_repo_connect_first_success,
		ru: ru.tab_repo_connect_first_success
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_connect_change_success = (params = {}, options = {}) => {
	return {
		en: en.tab_repo_connect_change_success,
		ru: ru.tab_repo_connect_change_success
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_connect_copied = (params = {}, options = {}) => {
	return {
		en: en.tab_repo_connect_copied,
		ru: ru.tab_repo_connect_copied
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_connection_title = (params = {}, options = {}) => {
	return {
		en: en.tab_repo_connection_title,
		ru: ru.tab_repo_connection_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_connection_primary = (params = {}, options = {}) => {
	return {
		en: en.tab_repo_connection_primary,
		ru: ru.tab_repo_connection_primary
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_connection_or = (params = {}, options = {}) => {
	return {
		en: en.tab_repo_connection_or,
		ru: ru.tab_repo_connection_or
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_connection_existing = (params = {}, options = {}) => {
	return {
		en: en.tab_repo_connection_existing,
		ru: ru.tab_repo_connection_existing
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_connection_submit = (params = {}, options = {}) => {
	return {
		en: en.tab_repo_connection_submit,
		ru: ru.tab_repo_connection_submit
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_connection_ifPrimary = (params = {}, options = {}) => {
	return {
		en: en.tab_repo_connection_ifPrimary,
		ru: ru.tab_repo_connection_ifPrimary
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_helper = (params = {}, options = {}) => {
	return {
		en: en.tab_repo_helper,
		ru: ru.tab_repo_helper
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_helper_data = (params = {}, options = {}) => {
	return {
		en: en.tab_repo_helper_data,
		ru: ru.tab_repo_helper_data
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_delete_git_confirm = (params = {}, options = {}) => {
	return {
		en: en.tab_repo_delete_git_confirm,
		ru: ru.tab_repo_delete_git_confirm
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_gitWebhook_v2_remoteRepo_placeholder = (params = {}, options = {}) => {
	return {
		en: en.tab_repo_gitWebhook_v2_remoteRepo_placeholder,
		ru: ru.tab_repo_gitWebhook_v2_remoteRepo_placeholder
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_gitWebhook_v2_remoteBranch_placeholder = (params = {}, options = {}) => {
	return {
		en: en.tab_repo_gitWebhook_v2_remoteBranch_placeholder,
		ru: ru.tab_repo_gitWebhook_v2_remoteBranch_placeholder
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_gitWebhook_v2_remoteBranch_error = (params = {}, options = {}) => {
	return {
		en: en.tab_repo_gitWebhook_v2_remoteBranch_error,
		ru: ru.tab_repo_gitWebhook_v2_remoteBranch_error
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_gitWebhook_v2_fetchBranch_error = (params = {}, options = {}) => {
	return {
		en: en.tab_repo_gitWebhook_v2_fetchBranch_error,
		ru: ru.tab_repo_gitWebhook_v2_fetchBranch_error
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_gitWebhook_v2_post_success = (params = {}, options = {}) => {
	return {
		en: en.tab_repo_gitWebhook_v2_post_success,
		ru: ru.tab_repo_gitWebhook_v2_post_success
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_gitWebhook_v2_edit_success = (params = {}, options = {}) => {
	return {
		en: en.tab_repo_gitWebhook_v2_edit_success,
		ru: ru.tab_repo_gitWebhook_v2_edit_success
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_gitWebhook_v2_delete_success = (params = {}, options = {}) => {
	return {
		en: en.tab_repo_gitWebhook_v2_delete_success,
		ru: ru.tab_repo_gitWebhook_v2_delete_success
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_gitWebhook_v2_delete_error = (params = {}, options = {}) => {
	return {
		en: en.tab_repo_gitWebhook_v2_delete_error,
		ru: ru.tab_repo_gitWebhook_v2_delete_error
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_gitWebhook_v2_existing_error_hint = (params = {}, options = {}) => {
	return {
		en: en.tab_repo_gitWebhook_v2_existing_error_hint,
		ru: ru.tab_repo_gitWebhook_v2_existing_error_hint
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_delete_file_confirmation = (params = {}, options = {}) => {
	return {
		en: en.tab_repo_delete_file_confirmation,
		ru: ru.tab_repo_delete_file_confirmation
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_delete_file_doNotAskAgain = (params = {}, options = {}) => {
	return {
		en: en.tab_repo_delete_file_doNotAskAgain,
		ru: ru.tab_repo_delete_file_doNotAskAgain
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_config_field_environment_label = (params = {}, options = {}) => {
	return {
		en: en.tab_config_field_environment_label,
		ru: ru.tab_config_field_environment_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_config_field_toolchain_label = (params = {}, options = {}) => {
	return {
		en: en.tab_config_field_toolchain_label,
		ru: ru.tab_config_field_toolchain_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_config_field_version_label = (params = {}, options = {}) => {
	return {
		en: en.tab_config_field_version_label,
		ru: ru.tab_config_field_version_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_config_field_change_success = (params = {}, options = {}) => {
	return {
		en: en.tab_config_field_change_success,
		ru: ru.tab_config_field_change_success
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_config_mainFileName_error_wrongName = (params = {}, options = {}) => {
	return {
		en: en.tab_config_mainFileName_error_wrongName,
		ru: ru.tab_config_mainFileName_error_wrongName
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_config_mainFileName_error_wrongPath = (params = {}, options = {}) => {
	return {
		en: en.tab_config_mainFileName_error_wrongPath,
		ru: ru.tab_config_mainFileName_error_wrongPath
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_config_python_requirementsPath_error_noFile = (params = {}, options = {}) => {
	return {
		en: en.tab_config_python_requirementsPath_error_noFile,
		ru: ru.tab_config_python_requirementsPath_error_noFile
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_config_python_requirementsPath_error_wrongName = (params = {}, options = {}) => {
	return {
		en: en.tab_config_python_requirementsPath_error_wrongName,
		ru: ru.tab_config_python_requirementsPath_error_wrongName
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_config_python_requirementsPath_error_wrongPath = (params = {}, options = {}) => {
	return {
		en: en.tab_config_python_requirementsPath_error_wrongPath,
		ru: ru.tab_config_python_requirementsPath_error_wrongPath
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_build_log = (params = {}, options = {}) => {
	return {
		en: en.tab_build_log,
		ru: ru.tab_build_log
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_run_log = (params = {}, options = {}) => {
	return {
		en: en.tab_run_log,
		ru: ru.tab_run_log
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_db_log = (params = {}, options = {}) => {
	return {
		en: en.tab_db_log,
		ru: ru.tab_db_log
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_system_log = (params = {}, options = {}) => {
	return {
		en: en.tab_system_log,
		ru: ru.tab_system_log
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_logs_alertTitle_default = (params = {}, options = {}) => {
	return {
		en: en.tab_logs_alertTitle_default,
		ru: ru.tab_logs_alertTitle_default
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_logs_alertTitle_build = (params = {}, options = {}) => {
	return {
		en: en.tab_logs_alertTitle_build,
		ru: ru.tab_logs_alertTitle_build
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_logs_alertTitle_run = (params = {}, options = {}) => {
	return {
		en: en.tab_logs_alertTitle_run,
		ru: ru.tab_logs_alertTitle_run
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_logs_alert_errors = (params = {}, options = {}) => {
	return {
		en: en.tab_logs_alert_errors,
		ru: ru.tab_logs_alert_errors
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_logs_loading = (params = {}, options = {}) => {
	return {
		en: en.tab_logs_loading,
		ru: ru.tab_logs_loading
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_logs_download_hint = (params = {}, options = {}) => {
	return {
		en: en.tab_logs_download_hint,
		ru: ru.tab_logs_download_hint
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_logs_load_logs = (params = {}, options = {}) => {
	return {
		en: en.tab_logs_load_logs,
		ru: ru.tab_logs_load_logs
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_logs_query = (params = {}, options = {}) => {
	return {
		en: en.tab_logs_query,
		ru: ru.tab_logs_query
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_logs_limit = (params = {}, options = {}) => {
	return {
		en: en.tab_logs_limit,
		ru: ru.tab_logs_limit
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_logs_show_date = (params = {}, options = {}) => {
	return {
		en: en.tab_logs_show_date,
		ru: ru.tab_logs_show_date
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_logs_tail_mode = (params = {}, options = {}) => {
	return {
		en: en.tab_logs_tail_mode,
		ru: ru.tab_logs_tail_mode
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_logs_no_logs = (params = {}, options = {}) => {
	return {
		en: en.tab_logs_no_logs,
		ru: ru.tab_logs_no_logs
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_envvars_title = (params = {}, options = {}) => {
	return {
		en: en.tab_envvars_title,
		ru: ru.tab_envvars_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_envvars_noVars = (params = {}, options = {}) => {
	return {
		en: en.tab_envvars_noVars,
		ru: ru.tab_envvars_noVars
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_envvars_alert_desc = (params = {}, options = {}) => {
	return {
		en: en.tab_envvars_alert_desc,
		ru: ru.tab_envvars_alert_desc
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_envvars_dialog_secret_btn = (params = {}, options = {}) => {
	return {
		en: en.tab_envvars_dialog_secret_btn,
		ru: ru.tab_envvars_dialog_secret_btn
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_envvars_dialog_secret_title = (params = {}, options = {}) => {
	return {
		en: en.tab_envvars_dialog_secret_title,
		ru: ru.tab_envvars_dialog_secret_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_envvars_dialog_secret_description = (params = {}, options = {}) => {
	return {
		en: en.tab_envvars_dialog_secret_description,
		ru: ru.tab_envvars_dialog_secret_description
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_envvars_dialog_field_value = (params = {}, options = {}) => {
	return {
		en: en.tab_envvars_dialog_field_value,
		ru: ru.tab_envvars_dialog_field_value
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_envvars_dialog_var_btn = (params = {}, options = {}) => {
	return {
		en: en.tab_envvars_dialog_var_btn,
		ru: ru.tab_envvars_dialog_var_btn
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_envvars_dialog_var_title = (params = {}, options = {}) => {
	return {
		en: en.tab_envvars_dialog_var_title,
		ru: ru.tab_envvars_dialog_var_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_envvars_dialog_var_description = (params = {}, options = {}) => {
	return {
		en: en.tab_envvars_dialog_var_description,
		ru: ru.tab_envvars_dialog_var_description
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_envvars_dialog_var_name_error_quotes = (params = {}, options = {}) => {
	return {
		en: en.tab_envvars_dialog_var_name_error_quotes,
		ru: ru.tab_envvars_dialog_var_name_error_quotes
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_envvars_dialog_var_value_error_quotes = (params = {}, options = {}) => {
	return {
		en: en.tab_envvars_dialog_var_value_error_quotes,
		ru: ru.tab_envvars_dialog_var_value_error_quotes
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_envvars_table_column_name = (params = {}, options = {}) => {
	return {
		en: en.tab_envvars_table_column_name,
		ru: ru.tab_envvars_table_column_name
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_envvars_table_column_value = (params = {}, options = {}) => {
	return {
		en: en.tab_envvars_table_column_value,
		ru: ru.tab_envvars_table_column_value
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_envvars_table_column_secret = (params = {}, options = {}) => {
	return {
		en: en.tab_envvars_table_column_secret,
		ru: ru.tab_envvars_table_column_secret
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_envvars_table_actions = (params = {}, options = {}) => {
	return {
		en: en.tab_envvars_table_actions,
		ru: ru.tab_envvars_table_actions
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_envvars_table_action_changeVar = (params = {}, options = {}) => {
	return {
		en: en.tab_envvars_table_action_changeVar,
		ru: ru.tab_envvars_table_action_changeVar
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_envvars_dialog_changeVar_title = (params = {}, options = {}) => {
	return {
		en: en.tab_envvars_dialog_changeVar_title,
		ru: ru.tab_envvars_dialog_changeVar_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_envvars_dialog_changeVar_desc = (params = {}, options = {}) => {
	return {
		en: en.tab_envvars_dialog_changeVar_desc,
		ru: ru.tab_envvars_dialog_changeVar_desc
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_envvars_dialog_changeSec_title = (params = {}, options = {}) => {
	return {
		en: en.tab_envvars_dialog_changeSec_title,
		ru: ru.tab_envvars_dialog_changeSec_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_envvars_dialog_changeSec_desc = (params = {}, options = {}) => {
	return {
		en: en.tab_envvars_dialog_changeSec_desc,
		ru: ru.tab_envvars_dialog_changeSec_desc
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_envvars_table_action_deleteVar = (params = {}, options = {}) => {
	return {
		en: en.tab_envvars_table_action_deleteVar,
		ru: ru.tab_envvars_table_action_deleteVar
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_envvars_dialog_delete_title = (params = {}, options = {}) => {
	return {
		en: en.tab_envvars_dialog_delete_title,
		ru: ru.tab_envvars_dialog_delete_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ name: NonNullable<unknown> }} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_envvars_dialog_delete_desc = (params , options = {}) => {
	return {
		en: en.tab_envvars_dialog_delete_desc,
		ru: ru.tab_envvars_dialog_delete_desc
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_page_title_im = (params = {}, options = {}) => {
	return {
		en: en.tab_domains_page_title_im,
		ru: ru.tab_domains_page_title_im
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_column_action = (params = {}, options = {}) => {
	return {
		en: en.tab_domains_column_action,
		ru: ru.tab_domains_column_action
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_column_connectionType = (params = {}, options = {}) => {
	return {
		en: en.tab_domains_column_connectionType,
		ru: ru.tab_domains_column_connectionType
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_column_type = (params = {}, options = {}) => {
	return {
		en: en.tab_domains_column_type,
		ru: ru.tab_domains_column_type
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_column_type_internal = (params = {}, options = {}) => {
	return {
		en: en.tab_domains_column_type_internal,
		ru: ru.tab_domains_column_type_internal
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_column_type_external = (params = {}, options = {}) => {
	return {
		en: en.tab_domains_column_type_external,
		ru: ru.tab_domains_column_type_external
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_domainType_external = (params = {}, options = {}) => {
	return {
		en: en.tab_domains_domainType_external,
		ru: ru.tab_domains_domainType_external
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_domainType_internal = (params = {}, options = {}) => {
	return {
		en: en.tab_domains_domainType_internal,
		ru: ru.tab_domains_domainType_internal
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_editDialog_title = (params = {}, options = {}) => {
	return {
		en: en.tab_domains_editDialog_title,
		ru: ru.tab_domains_editDialog_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_editDialog_desc_deactivate = (params = {}, options = {}) => {
	return {
		en: en.tab_domains_editDialog_desc_deactivate,
		ru: ru.tab_domains_editDialog_desc_deactivate
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_editDialog_desc_activate = (params = {}, options = {}) => {
	return {
		en: en.tab_domains_editDialog_desc_activate,
		ru: ru.tab_domains_editDialog_desc_activate
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_deleteDialog_title = (params = {}, options = {}) => {
	return {
		en: en.tab_domains_deleteDialog_title,
		ru: ru.tab_domains_deleteDialog_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ domainName: NonNullable<unknown> }} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_deleteDialog_desc = (params , options = {}) => {
	return {
		en: en.tab_domains_deleteDialog_desc,
		ru: ru.tab_domains_deleteDialog_desc
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ ingressType: NonNullable<unknown> }} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_editIngressType_success = (params , options = {}) => {
	return {
		en: en.tab_domains_editIngressType_success,
		ru: ru.tab_domains_editIngressType_success
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_editIngressType_title = (params = {}, options = {}) => {
	return {
		en: en.tab_domains_editIngressType_title,
		ru: ru.tab_domains_editIngressType_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_editIngressType_desc = (params = {}, options = {}) => {
	return {
		en: en.tab_domains_editIngressType_desc,
		ru: ru.tab_domains_editIngressType_desc
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_add_btn = (params = {}, options = {}) => {
	return {
		en: en.tab_domains_add_btn,
		ru: ru.tab_domains_add_btn
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_addDialog_title = (params = {}, options = {}) => {
	return {
		en: en.tab_domains_addDialog_title,
		ru: ru.tab_domains_addDialog_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_addDialog_field_connectionType = (params = {}, options = {}) => {
	return {
		en: en.tab_domains_addDialog_field_connectionType,
		ru: ru.tab_domains_addDialog_field_connectionType
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_addDialog_field_domainType = (params = {}, options = {}) => {
	return {
		en: en.tab_domains_addDialog_field_domainType,
		ru: ru.tab_domains_addDialog_field_domainType
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_addDialog_field_your = (params = {}, options = {}) => {
	return {
		en: en.tab_domains_addDialog_field_your,
		ru: ru.tab_domains_addDialog_field_your
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_addDialog_field_free = (params = {}, options = {}) => {
	return {
		en: en.tab_domains_addDialog_field_free,
		ru: ru.tab_domains_addDialog_field_free
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_addDialog_steps_title = (params = {}, options = {}) => {
	return {
		en: en.tab_domains_addDialog_steps_title,
		ru: ru.tab_domains_addDialog_steps_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ externalIp: NonNullable<unknown>, ownerName: NonNullable<unknown>, slug: NonNullable<unknown> }} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_addDialog_steps_1 = (params , options = {}) => {
	return {
		en: en.tab_domains_addDialog_steps_1,
		ru: ru.tab_domains_addDialog_steps_1
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_addDialog_steps_2 = (params = {}, options = {}) => {
	return {
		en: en.tab_domains_addDialog_steps_2,
		ru: ru.tab_domains_addDialog_steps_2
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_addDialog_steps_3 = (params = {}, options = {}) => {
	return {
		en: en.tab_domains_addDialog_steps_3,
		ru: ru.tab_domains_addDialog_steps_3
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_addDialog_field_name = (params = {}, options = {}) => {
	return {
		en: en.tab_domains_addDialog_field_name,
		ru: ru.tab_domains_addDialog_field_name
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_addDialog_field_placeholder = (params = {}, options = {}) => {
	return {
		en: en.tab_domains_addDialog_field_placeholder,
		ru: ru.tab_domains_addDialog_field_placeholder
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_addDialog_field_name_placeholder = (params = {}, options = {}) => {
	return {
		en: en.tab_domains_addDialog_field_name_placeholder,
		ru: ru.tab_domains_addDialog_field_name_placeholder
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_addDialog_additionalSettings_title = (params = {}, options = {}) => {
	return {
		en: en.tab_domains_addDialog_additionalSettings_title,
		ru: ru.tab_domains_addDialog_additionalSettings_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_addDialog_additionalSettings_section_ports = (params = {}, options = {}) => {
	return {
		en: en.tab_domains_addDialog_additionalSettings_section_ports,
		ru: ru.tab_domains_addDialog_additionalSettings_section_ports
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_addDialog_additionalSettings_field_url_placeholder = (params = {}, options = {}) => {
	return {
		en: en.tab_domains_addDialog_additionalSettings_field_url_placeholder,
		ru: ru.tab_domains_addDialog_additionalSettings_field_url_placeholder
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_addDialog_additionalSettings_field_url_error = (params = {}, options = {}) => {
	return {
		en: en.tab_domains_addDialog_additionalSettings_field_url_error,
		ru: ru.tab_domains_addDialog_additionalSettings_field_url_error
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_addDialog_additionalSettings_field_url_req = (params = {}, options = {}) => {
	return {
		en: en.tab_domains_addDialog_additionalSettings_field_url_req,
		ru: ru.tab_domains_addDialog_additionalSettings_field_url_req
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_addDialog_additionalSettings_field_port_placeholder = (params = {}, options = {}) => {
	return {
		en: en.tab_domains_addDialog_additionalSettings_field_port_placeholder,
		ru: ru.tab_domains_addDialog_additionalSettings_field_port_placeholder
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_addDialog_additionalSettings_field_port_req = (params = {}, options = {}) => {
	return {
		en: en.tab_domains_addDialog_additionalSettings_field_port_req,
		ru: ru.tab_domains_addDialog_additionalSettings_field_port_req
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_addDialog_additionalSettings_field_port_numberError = (params = {}, options = {}) => {
	return {
		en: en.tab_domains_addDialog_additionalSettings_field_port_numberError,
		ru: ru.tab_domains_addDialog_additionalSettings_field_port_numberError
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_addDialog_success = (params = {}, options = {}) => {
	return {
		en: en.tab_domains_addDialog_success,
		ru: ru.tab_domains_addDialog_success
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_ports_success = (params = {}, options = {}) => {
	return {
		en: en.tab_domains_ports_success,
		ru: ru.tab_domains_ports_success
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_backups_title = (params = {}, options = {}) => {
	return {
		en: en.tab_backups_title,
		ru: ru.tab_backups_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_backups_helper = (params = {}, options = {}) => {
	return {
		en: en.tab_backups_helper,
		ru: ru.tab_backups_helper
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_backups_noAccess = (params = {}, options = {}) => {
	return {
		en: en.tab_backups_noAccess,
		ru: ru.tab_backups_noAccess
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_backups_noBackups = (params = {}, options = {}) => {
	return {
		en: en.tab_backups_noBackups,
		ru: ru.tab_backups_noBackups
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_backups_ready_hint_EMPTY = (params = {}, options = {}) => {
	return {
		en: en.tab_backups_ready_hint_EMPTY,
		ru: ru.tab_backups_ready_hint_EMPTY
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_backups_ready_hint_READY = (params = {}, options = {}) => {
	return {
		en: en.tab_backups_ready_hint_READY,
		ru: ru.tab_backups_ready_hint_READY
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_backups_ready_hint_ERROR = (params = {}, options = {}) => {
	return {
		en: en.tab_backups_ready_hint_ERROR,
		ru: ru.tab_backups_ready_hint_ERROR
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_backups_ready_default = (params = {}, options = {}) => {
	return {
		en: en.tab_backups_ready_default,
		ru: ru.tab_backups_ready_default
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_backups_download = (params = {}, options = {}) => {
	return {
		en: en.tab_backups_download,
		ru: ru.tab_backups_download
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_backups_recovery_title = (params = {}, options = {}) => {
	return {
		en: en.tab_backups_recovery_title,
		ru: ru.tab_backups_recovery_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_backups_recovery_alert = (params = {}, options = {}) => {
	return {
		en: en.tab_backups_recovery_alert,
		ru: ru.tab_backups_recovery_alert
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_backups_recovery_alert_409 = (params = {}, options = {}) => {
	return {
		en: en.tab_backups_recovery_alert_409,
		ru: ru.tab_backups_recovery_alert_409
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_backups_recovery_button = (params = {}, options = {}) => {
	return {
		en: en.tab_backups_recovery_button,
		ru: ru.tab_backups_recovery_button
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_backups_recovery_success_notification = (params = {}, options = {}) => {
	return {
		en: en.tab_backups_recovery_success_notification,
		ru: ru.tab_backups_recovery_success_notification
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_backups_recovery_note = (params = {}, options = {}) => {
	return {
		en: en.tab_backups_recovery_note,
		ru: ru.tab_backups_recovery_note
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_tariff = (params = {}, options = {}) => {
	return {
		en: en.tab_tariff,
		ru: ru.tab_tariff
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_tariff_field_plan = (params = {}, options = {}) => {
	return {
		en: en.tab_tariff_field_plan,
		ru: ru.tab_tariff_field_plan
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_tariff_alert = (params = {}, options = {}) => {
	return {
		en: en.tab_tariff_alert,
		ru: ru.tab_tariff_alert
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_tariff_field_plan_placeholder = (params = {}, options = {}) => {
	return {
		en: en.tab_tariff_field_plan_placeholder,
		ru: ru.tab_tariff_field_plan_placeholder
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_tariff_changed_success = (params = {}, options = {}) => {
	return {
		en: en.tab_tariff_changed_success,
		ru: ru.tab_tariff_changed_success
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_tariff_managment = (params = {}, options = {}) => {
	return {
		en: en.tab_tariff_managment,
		ru: ru.tab_tariff_managment
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_tariff_managment_disk = (params = {}, options = {}) => {
	return {
		en: en.tab_tariff_managment_disk,
		ru: ru.tab_tariff_managment_disk
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_tariff_freeze = (params = {}, options = {}) => {
	return {
		en: en.tab_tariff_freeze,
		ru: ru.tab_tariff_freeze
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_tariff_freeze_btn = (params = {}, options = {}) => {
	return {
		en: en.tab_tariff_freeze_btn,
		ru: ru.tab_tariff_freeze_btn
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_tariff_freeze_success = (params = {}, options = {}) => {
	return {
		en: en.tab_tariff_freeze_success,
		ru: ru.tab_tariff_freeze_success
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_tariff_delete = (params = {}, options = {}) => {
	return {
		en: en.tab_tariff_delete,
		ru: ru.tab_tariff_delete
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_tariff_delete_project = (params = {}, options = {}) => {
	return {
		en: en.tab_tariff_delete_project,
		ru: ru.tab_tariff_delete_project
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_tariff_delete_description = (params = {}, options = {}) => {
	return {
		en: en.tab_tariff_delete_description,
		ru: ru.tab_tariff_delete_description
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ projectName: NonNullable<unknown> }} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_tariff_delete_title = (params , options = {}) => {
	return {
		en: en.tab_tariff_delete_title,
		ru: ru.tab_tariff_delete_title
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_tariff_delete_dialog_description = (params = {}, options = {}) => {
	return {
		en: en.tab_tariff_delete_dialog_description,
		ru: ru.tab_tariff_delete_dialog_description
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ projectName: NonNullable<unknown> }} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_tariff_delete_dialog_confirmText = (params , options = {}) => {
	return {
		en: en.tab_tariff_delete_dialog_confirmText,
		ru: ru.tab_tariff_delete_dialog_confirmText
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_tariff_delete_dialog_field_placeholder = (params = {}, options = {}) => {
	return {
		en: en.tab_tariff_delete_dialog_field_placeholder,
		ru: ru.tab_tariff_delete_dialog_field_placeholder
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_tariff_delete_dialog_failed = (params = {}, options = {}) => {
	return {
		en: en.tab_tariff_delete_dialog_failed,
		ru: ru.tab_tariff_delete_dialog_failed
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_notifactions = (params = {}, options = {}) => {
	return {
		en: en.tab_notifactions,
		ru: ru.tab_notifactions
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_notif_autoscaling = (params = {}, options = {}) => {
	return {
		en: en.tab_notif_autoscaling,
		ru: ru.tab_notif_autoscaling
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts = (params = {}, options = {}) => {
	return {
		en: en.tab_alerts_tab_alerts,
		ru: ru.tab_alerts_tab_alerts
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_interface = (params = {}, options = {}) => {
	return {
		en: en.tab_alerts_tab_interface,
		ru: ru.tab_alerts_tab_interface
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_dashboard = (params = {}, options = {}) => {
	return {
		en: en.tab_alerts_tab_dashboard,
		ru: ru.tab_alerts_tab_dashboard
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_success = (params = {}, options = {}) => {
	return {
		en: en.tab_alerts_tab_alerts_success,
		ru: ru.tab_alerts_tab_alerts_success
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ errorMessage: NonNullable<unknown> }} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_error = (params , options = {}) => {
	return {
		en: en.tab_alerts_tab_alerts_error,
		ru: ru.tab_alerts_tab_alerts_error
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_noAccess = (params = {}, options = {}) => {
	return {
		en: en.tab_alerts_tab_alerts_noAccess,
		ru: ru.tab_alerts_tab_alerts_noAccess
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_field_projectFailures = (params = {}, options = {}) => {
	return {
		en: en.tab_alerts_tab_alerts_field_projectFailures,
		ru: ru.tab_alerts_tab_alerts_field_projectFailures
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_field_cpuUsage = (params = {}, options = {}) => {
	return {
		en: en.tab_alerts_tab_alerts_field_cpuUsage,
		ru: ru.tab_alerts_tab_alerts_field_cpuUsage
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_field_ramUsage = (params = {}, options = {}) => {
	return {
		en: en.tab_alerts_tab_alerts_field_ramUsage,
		ru: ru.tab_alerts_tab_alerts_field_ramUsage
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_field_k8 = (params = {}, options = {}) => {
	return {
		en: en.tab_alerts_tab_alerts_field_k8,
		ru: ru.tab_alerts_tab_alerts_field_k8
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_field_buildFailed = (params = {}, options = {}) => {
	return {
		en: en.tab_alerts_tab_alerts_field_buildFailed,
		ru: ru.tab_alerts_tab_alerts_field_buildFailed
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_field_runFailed = (params = {}, options = {}) => {
	return {
		en: en.tab_alerts_tab_alerts_field_runFailed,
		ru: ru.tab_alerts_tab_alerts_field_runFailed
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_settings_field_channel = (params = {}, options = {}) => {
	return {
		en: en.tab_alerts_tab_alerts_settings_field_channel,
		ru: ru.tab_alerts_tab_alerts_settings_field_channel
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_settings_field_channel_placeholder = (params = {}, options = {}) => {
	return {
		en: en.tab_alerts_tab_alerts_settings_field_channel_placeholder,
		ru: ru.tab_alerts_tab_alerts_settings_field_channel_placeholder
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_settings_field_channel_email = (params = {}, options = {}) => {
	return {
		en: en.tab_alerts_tab_alerts_settings_field_channel_email,
		ru: ru.tab_alerts_tab_alerts_settings_field_channel_email
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_settings_field_channel_maxPerDay = (params = {}, options = {}) => {
	return {
		en: en.tab_alerts_tab_alerts_settings_field_channel_maxPerDay,
		ru: ru.tab_alerts_tab_alerts_settings_field_channel_maxPerDay
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_settings_enabled_tg_bot_link = (params = {}, options = {}) => {
	return {
		en: en.tab_alerts_tab_alerts_settings_enabled_tg_bot_link,
		ru: ru.tab_alerts_tab_alerts_settings_enabled_tg_bot_link
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_settings_enabled_tg_bot_link2 = (params = {}, options = {}) => {
	return {
		en: en.tab_alerts_tab_alerts_settings_enabled_tg_bot_link2,
		ru: ru.tab_alerts_tab_alerts_settings_enabled_tg_bot_link2
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_settings_disabled_tg_bot_link = (params = {}, options = {}) => {
	return {
		en: en.tab_alerts_tab_alerts_settings_disabled_tg_bot_link,
		ru: ru.tab_alerts_tab_alerts_settings_disabled_tg_bot_link
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_settings_disabled_tg_bot_link2 = (params = {}, options = {}) => {
	return {
		en: en.tab_alerts_tab_alerts_settings_disabled_tg_bot_link2,
		ru: ru.tab_alerts_tab_alerts_settings_disabled_tg_bot_link2
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_settings_enabled_tg_bot_link_hint = (params = {}, options = {}) => {
	return {
		en: en.tab_alerts_tab_alerts_settings_enabled_tg_bot_link_hint,
		ru: ru.tab_alerts_tab_alerts_settings_enabled_tg_bot_link_hint
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_settings_enabled_tg_bot_alert = (params = {}, options = {}) => {
	return {
		en: en.tab_alerts_tab_alerts_settings_enabled_tg_bot_alert,
		ru: ru.tab_alerts_tab_alerts_settings_enabled_tg_bot_alert
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_settings_enabled_tg_bot_qrAlt = (params = {}, options = {}) => {
	return {
		en: en.tab_alerts_tab_alerts_settings_enabled_tg_bot_qrAlt,
		ru: ru.tab_alerts_tab_alerts_settings_enabled_tg_bot_qrAlt
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_settings_tg_alertValue = (params = {}, options = {}) => {
	return {
		en: en.tab_alerts_tab_alerts_settings_tg_alertValue,
		ru: ru.tab_alerts_tab_alerts_settings_tg_alertValue
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_settings_tg_alertValue_placeholder = (params = {}, options = {}) => {
	return {
		en: en.tab_alerts_tab_alerts_settings_tg_alertValue_placeholder,
		ru: ru.tab_alerts_tab_alerts_settings_tg_alertValue_placeholder
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_settings_yamlConfig = (params = {}, options = {}) => {
	return {
		en: en.tab_alerts_tab_alerts_settings_yamlConfig,
		ru: ru.tab_alerts_tab_alerts_settings_yamlConfig
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_settings_yamlConfig_placeholder = (params = {}, options = {}) => {
	return {
		en: en.tab_alerts_tab_alerts_settings_yamlConfig_placeholder,
		ru: ru.tab_alerts_tab_alerts_settings_yamlConfig_placeholder
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_settings_exit_dialog_title = (params = {}, options = {}) => {
	return {
		en: en.tab_alerts_tab_alerts_settings_exit_dialog_title,
		ru: ru.tab_alerts_tab_alerts_settings_exit_dialog_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_settings_exit_dialog_desc = (params = {}, options = {}) => {
	return {
		en: en.tab_alerts_tab_alerts_settings_exit_dialog_desc,
		ru: ru.tab_alerts_tab_alerts_settings_exit_dialog_desc
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_settings_exit_dialog_closeWithoutSaving = (params = {}, options = {}) => {
	return {
		en: en.tab_alerts_tab_alerts_settings_exit_dialog_closeWithoutSaving,
		ru: ru.tab_alerts_tab_alerts_settings_exit_dialog_closeWithoutSaving
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_interface_title = (params = {}, options = {}) => {
	return {
		en: en.tab_alerts_tab_interface_title,
		ru: ru.tab_alerts_tab_interface_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_interface_changed_success = (params = {}, options = {}) => {
	return {
		en: en.tab_alerts_tab_interface_changed_success,
		ru: ru.tab_alerts_tab_interface_changed_success
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_dashboard_metric_ram_label = (params = {}, options = {}) => {
	return {
		en: en.tab_alerts_tab_dashboard_metric_ram_label,
		ru: ru.tab_alerts_tab_dashboard_metric_ram_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_dashboard_metric_cpu_label = (params = {}, options = {}) => {
	return {
		en: en.tab_alerts_tab_dashboard_metric_cpu_label,
		ru: ru.tab_alerts_tab_dashboard_metric_cpu_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_dashboard_metric_cpu_throttling_label = (params = {}, options = {}) => {
	return {
		en: en.tab_alerts_tab_dashboard_metric_cpu_throttling_label,
		ru: ru.tab_alerts_tab_dashboard_metric_cpu_throttling_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_dashboard_noAccess = (params = {}, options = {}) => {
	return {
		en: en.tab_alerts_tab_dashboard_noAccess,
		ru: ru.tab_alerts_tab_dashboard_noAccess
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_dashboard_chart_loading = (params = {}, options = {}) => {
	return {
		en: en.tab_alerts_tab_dashboard_chart_loading,
		ru: ru.tab_alerts_tab_dashboard_chart_loading
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_dashboard_chart_error = (params = {}, options = {}) => {
	return {
		en: en.tab_alerts_tab_dashboard_chart_error,
		ru: ru.tab_alerts_tab_dashboard_chart_error
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_dashboard_chart_noData = (params = {}, options = {}) => {
	return {
		en: en.tab_alerts_tab_dashboard_chart_noData,
		ru: ru.tab_alerts_tab_dashboard_chart_noData
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_dashboard_chart_time = (params = {}, options = {}) => {
	return {
		en: en.tab_alerts_tab_dashboard_chart_time,
		ru: ru.tab_alerts_tab_dashboard_chart_time
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_dashboard_chart_usage = (params = {}, options = {}) => {
	return {
		en: en.tab_alerts_tab_dashboard_chart_usage,
		ru: ru.tab_alerts_tab_dashboard_chart_usage
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_dashboard_chart_throttling = (params = {}, options = {}) => {
	return {
		en: en.tab_alerts_tab_dashboard_chart_throttling,
		ru: ru.tab_alerts_tab_dashboard_chart_throttling
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_dashboard_chart_seconds = (params = {}, options = {}) => {
	return {
		en: en.tab_alerts_tab_dashboard_chart_seconds,
		ru: ru.tab_alerts_tab_dashboard_chart_seconds
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_failure_title = (params = {}, options = {}) => {
	return {
		en: en.tab_alerts_failure_title,
		ru: ru.tab_alerts_failure_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_failure_field_maxPerDay = (params = {}, options = {}) => {
	return {
		en: en.tab_alerts_failure_field_maxPerDay,
		ru: ru.tab_alerts_failure_field_maxPerDay
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_failure_field_minUptime = (params = {}, options = {}) => {
	return {
		en: en.tab_alerts_failure_field_minUptime,
		ru: ru.tab_alerts_failure_field_minUptime
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_failure_hint = (params = {}, options = {}) => {
	return {
		en: en.tab_alerts_failure_hint,
		ru: ru.tab_alerts_failure_hint
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_error_popups_title = (params = {}, options = {}) => {
	return {
		en: en.tab_alerts_error_popups_title,
		ru: ru.tab_alerts_error_popups_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_autoscaling = (params = {}, options = {}) => {
	return {
		en: en.tab_alerts_autoscaling,
		ru: ru.tab_alerts_autoscaling
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_autoscaling_description = (params = {}, options = {}) => {
	return {
		en: en.tab_alerts_autoscaling_description,
		ru: ru.tab_alerts_autoscaling_description
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_autoscaling_changed_success = (params = {}, options = {}) => {
	return {
		en: en.tab_alerts_autoscaling_changed_success,
		ru: ru.tab_alerts_autoscaling_changed_success
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_rollbacks_table_hash = (params = {}, options = {}) => {
	return {
		en: en.tab_rollbacks_table_hash,
		ru: ru.tab_rollbacks_table_hash
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_rollbacks_table_commitDate = (params = {}, options = {}) => {
	return {
		en: en.tab_rollbacks_table_commitDate,
		ru: ru.tab_rollbacks_table_commitDate
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_rollbacks_table_statusCode = (params = {}, options = {}) => {
	return {
		en: en.tab_rollbacks_table_statusCode,
		ru: ru.tab_rollbacks_table_statusCode
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_rollbacks_table_stored = (params = {}, options = {}) => {
	return {
		en: en.tab_rollbacks_table_stored,
		ru: ru.tab_rollbacks_table_stored
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_rollbacks_table_stored_hint = (params = {}, options = {}) => {
	return {
		en: en.tab_rollbacks_table_stored_hint,
		ru: ru.tab_rollbacks_table_stored_hint
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_rollbacks_table_protected = (params = {}, options = {}) => {
	return {
		en: en.tab_rollbacks_table_protected,
		ru: ru.tab_rollbacks_table_protected
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_rollbacks_table_inUse = (params = {}, options = {}) => {
	return {
		en: en.tab_rollbacks_table_inUse,
		ru: ru.tab_rollbacks_table_inUse
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_rollbacks_table_actions_runVersion = (params = {}, options = {}) => {
	return {
		en: en.tab_rollbacks_table_actions_runVersion,
		ru: ru.tab_rollbacks_table_actions_runVersion
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_rollbacks_table_actions_rebuildVersion = (params = {}, options = {}) => {
	return {
		en: en.tab_rollbacks_table_actions_rebuildVersion,
		ru: ru.tab_rollbacks_table_actions_rebuildVersion
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_rollbacks_table_actions_delete = (params = {}, options = {}) => {
	return {
		en: en.tab_rollbacks_table_actions_delete,
		ru: ru.tab_rollbacks_table_actions_delete
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_rollbacks_table_actions_delete_confirm = (params = {}, options = {}) => {
	return {
		en: en.tab_rollbacks_table_actions_delete_confirm,
		ru: ru.tab_rollbacks_table_actions_delete_confirm
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_rollbacks_table_actions_delete_archive = (params = {}, options = {}) => {
	return {
		en: en.tab_rollbacks_table_actions_delete_archive,
		ru: ru.tab_rollbacks_table_actions_delete_archive
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_rollbacks_table_actions_delete_archive_confirm = (params = {}, options = {}) => {
	return {
		en: en.tab_rollbacks_table_actions_delete_archive_confirm,
		ru: ru.tab_rollbacks_table_actions_delete_archive_confirm
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_rollbacks_table_actions_rollbackVersion = (params = {}, options = {}) => {
	return {
		en: en.tab_rollbacks_table_actions_rollbackVersion,
		ru: ru.tab_rollbacks_table_actions_rollbackVersion
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_rollbacks_table_actions_rollbackVersion_confirm = (params = {}, options = {}) => {
	return {
		en: en.tab_rollbacks_table_actions_rollbackVersion_confirm,
		ru: ru.tab_rollbacks_table_actions_rollbackVersion_confirm
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_rollbacks_table_actions_saveFromDel = (params = {}, options = {}) => {
	return {
		en: en.tab_rollbacks_table_actions_saveFromDel,
		ru: ru.tab_rollbacks_table_actions_saveFromDel
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_rollbacks_table_actions_saveFromDel_confirm = (params = {}, options = {}) => {
	return {
		en: en.tab_rollbacks_table_actions_saveFromDel_confirm,
		ru: ru.tab_rollbacks_table_actions_saveFromDel_confirm
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_rollbacks_table_actions_removeSaveFromDel = (params = {}, options = {}) => {
	return {
		en: en.tab_rollbacks_table_actions_removeSaveFromDel,
		ru: ru.tab_rollbacks_table_actions_removeSaveFromDel
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_rollbacks_table_actions_removeSaveFromDel_confirm = (params = {}, options = {}) => {
	return {
		en: en.tab_rollbacks_table_actions_removeSaveFromDel_confirm,
		ru: ru.tab_rollbacks_table_actions_removeSaveFromDel_confirm
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const snackbar_phrase_start = (params = {}, options = {}) => {
	return {
		en: en.snackbar_phrase_start,
		ru: ru.snackbar_phrase_start
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const snackbar_phrase_link = (params = {}, options = {}) => {
	return {
		en: en.snackbar_phrase_link,
		ru: ru.snackbar_phrase_link
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const snackbar_phrase_end = (params = {}, options = {}) => {
	return {
		en: en.snackbar_phrase_end,
		ru: ru.snackbar_phrase_end
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const footer_socials_title = (params = {}, options = {}) => {
	return {
		en: en.footer_socials_title,
		ru: ru.footer_socials_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const footer_socials_vk = (params = {}, options = {}) => {
	return {
		en: en.footer_socials_vk,
		ru: ru.footer_socials_vk
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const footer_socials_telegram = (params = {}, options = {}) => {
	return {
		en: en.footer_socials_telegram,
		ru: ru.footer_socials_telegram
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const footer_socials_habr = (params = {}, options = {}) => {
	return {
		en: en.footer_socials_habr,
		ru: ru.footer_socials_habr
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const footer_techsupport_title = (params = {}, options = {}) => {
	return {
		en: en.footer_techsupport_title,
		ru: ru.footer_techsupport_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const footer_techsupport_timezone = (params = {}, options = {}) => {
	return {
		en: en.footer_techsupport_timezone,
		ru: ru.footer_techsupport_timezone
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const footer_support_tgChat = (params = {}, options = {}) => {
	return {
		en: en.footer_support_tgChat,
		ru: ru.footer_support_tgChat
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const repo_download_files_success = (params = {}, options = {}) => {
	return {
		en: en.repo_download_files_success,
		ru: ru.repo_download_files_success
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const repo_download_files_error = (params = {}, options = {}) => {
	return {
		en: en.repo_download_files_error,
		ru: ru.repo_download_files_error
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const persistent_snackbar_BUILD = (params = {}, options = {}) => {
	return {
		en: en.persistent_snackbar_BUILD,
		ru: ru.persistent_snackbar_BUILD
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const persistent_snackbar_RUN = (params = {}, options = {}) => {
	return {
		en: en.persistent_snackbar_RUN,
		ru: ru.persistent_snackbar_RUN
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const persistent_snackbar_RELEASE = (params = {}, options = {}) => {
	return {
		en: en.persistent_snackbar_RELEASE,
		ru: ru.persistent_snackbar_RELEASE
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ stage: NonNullable<unknown> }} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const persistent_snackbar_msgTitle = (params , options = {}) => {
	return {
		en: en.persistent_snackbar_msgTitle,
		ru: ru.persistent_snackbar_msgTitle
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const llm_main_page_warning_title = (params = {}, options = {}) => {
	return {
		en: en.llm_main_page_warning_title,
		ru: ru.llm_main_page_warning_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const llm_main_page_warning_desc = (params = {}, options = {}) => {
	return {
		en: en.llm_main_page_warning_desc,
		ru: ru.llm_main_page_warning_desc
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const llm_main_page_connect_token = (params = {}, options = {}) => {
	return {
		en: en.llm_main_page_connect_token,
		ru: ru.llm_main_page_connect_token
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ modelName: NonNullable<unknown> }} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const llm_dialog_title = (params , options = {}) => {
	return {
		en: en.llm_dialog_title,
		ru: ru.llm_dialog_title
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ tokens: NonNullable<unknown> }} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const llm_dialog_alert_title = (params , options = {}) => {
	return {
		en: en.llm_dialog_alert_title,
		ru: ru.llm_dialog_alert_title
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const llm_dialog_alert_desc = (params = {}, options = {}) => {
	return {
		en: en.llm_dialog_alert_desc,
		ru: ru.llm_dialog_alert_desc
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ modelName: NonNullable<unknown> }} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const llm_tab_info_model_name = (params , options = {}) => {
	return {
		en: en.llm_tab_info_model_name,
		ru: ru.llm_tab_info_model_name
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const llm_tab_info_model_docs = (params = {}, options = {}) => {
	return {
		en: en.llm_tab_info_model_docs,
		ru: ru.llm_tab_info_model_docs
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const llm_tab_info_token_title = (params = {}, options = {}) => {
	return {
		en: en.llm_tab_info_token_title,
		ru: ru.llm_tab_info_token_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const llm_tab_info_token_expires = (params = {}, options = {}) => {
	return {
		en: en.llm_tab_info_token_expires,
		ru: ru.llm_tab_info_token_expires
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const llm_tab_info_token_swagger = (params = {}, options = {}) => {
	return {
		en: en.llm_tab_info_token_swagger,
		ru: ru.llm_tab_info_token_swagger
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const llm_tab_info_instruction_title = (params = {}, options = {}) => {
	return {
		en: en.llm_tab_info_instruction_title,
		ru: ru.llm_tab_info_instruction_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ swaggerDomain: NonNullable<unknown> }} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const llm_tab_info_instruction_desc = (params , options = {}) => {
	return {
		en: en.llm_tab_info_instruction_desc,
		ru: ru.llm_tab_info_instruction_desc
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const llm_tab_info_token_empty = (params = {}, options = {}) => {
	return {
		en: en.llm_tab_info_token_empty,
		ru: ru.llm_tab_info_token_empty
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const llm_tab_subscription_card_tokens_title = (params = {}, options = {}) => {
	return {
		en: en.llm_tab_subscription_card_tokens_title,
		ru: ru.llm_tab_subscription_card_tokens_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const llm_tab_subscription_card_tokens_used = (params = {}, options = {}) => {
	return {
		en: en.llm_tab_subscription_card_tokens_used,
		ru: ru.llm_tab_subscription_card_tokens_used
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const llm_tab_subscription_card_tokens_left = (params = {}, options = {}) => {
	return {
		en: en.llm_tab_subscription_card_tokens_left,
		ru: ru.llm_tab_subscription_card_tokens_left
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const llm_tab_subscription_card_add_tokens = (params = {}, options = {}) => {
	return {
		en: en.llm_tab_subscription_card_add_tokens,
		ru: ru.llm_tab_subscription_card_add_tokens
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const llm_tab_subscription_card_sub_settings_title = (params = {}, options = {}) => {
	return {
		en: en.llm_tab_subscription_card_sub_settings_title,
		ru: ru.llm_tab_subscription_card_sub_settings_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ date: NonNullable<unknown> }} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const llm_tab_subscription_card_sub_settings_alert_desc = (params , options = {}) => {
	return {
		en: en.llm_tab_subscription_card_sub_settings_alert_desc,
		ru: ru.llm_tab_subscription_card_sub_settings_alert_desc
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ amount: NonNullable<unknown> }} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const llm_tab_subscription_card_sub_settings_alert_desc_2 = (params , options = {}) => {
	return {
		en: en.llm_tab_subscription_card_sub_settings_alert_desc_2,
		ru: ru.llm_tab_subscription_card_sub_settings_alert_desc_2
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const llm_tab_subscription_card_sub_settings_new_btn = (params = {}, options = {}) => {
	return {
		en: en.llm_tab_subscription_card_sub_settings_new_btn,
		ru: ru.llm_tab_subscription_card_sub_settings_new_btn
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const llm_tab_subscription_card_sub_settings_cancel_btn = (params = {}, options = {}) => {
	return {
		en: en.llm_tab_subscription_card_sub_settings_cancel_btn,
		ru: ru.llm_tab_subscription_card_sub_settings_cancel_btn
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const llm_tab_subscription_card_cancel_dialog_title = (params = {}, options = {}) => {
	return {
		en: en.llm_tab_subscription_card_cancel_dialog_title,
		ru: ru.llm_tab_subscription_card_cancel_dialog_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const llm_tab_subscription_card_cancel_dialog_desc = (params = {}, options = {}) => {
	return {
		en: en.llm_tab_subscription_card_cancel_dialog_desc,
		ru: ru.llm_tab_subscription_card_cancel_dialog_desc
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const llm_tab_subscription_card_sub_settings_alert_bonus_package_title = (params = {}, options = {}) => {
	return {
		en: en.llm_tab_subscription_card_sub_settings_alert_bonus_package_title,
		ru: ru.llm_tab_subscription_card_sub_settings_alert_bonus_package_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const llm_tab_subscription_card_sub_settings_alert_bonus_package_desc = (params = {}, options = {}) => {
	return {
		en: en.llm_tab_subscription_card_sub_settings_alert_bonus_package_desc,
		ru: ru.llm_tab_subscription_card_sub_settings_alert_bonus_package_desc
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const llm_tab_subscription_card_sub_settings_renew_button = (params = {}, options = {}) => {
	return {
		en: en.llm_tab_subscription_card_sub_settings_renew_button,
		ru: ru.llm_tab_subscription_card_sub_settings_renew_button
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const llm_tab_subscription_card_sub_settings_renew_title = (params = {}, options = {}) => {
	return {
		en: en.llm_tab_subscription_card_sub_settings_renew_title,
		ru: ru.llm_tab_subscription_card_sub_settings_renew_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const field_description = (params = {}, options = {}) => {
	return {
		en: en.field_description,
		ru: ru.field_description
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_config_python_scriptName_error_wrongName = (params = {}, options = {}) => {
	return {
		en: en.tab_config_python_scriptName_error_wrongName,
		ru: ru.tab_config_python_scriptName_error_wrongName
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "ru" | "en" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_config_python_scriptName_error_wrongPath = (params = {}, options = {}) => {
	return {
		en: en.tab_config_python_scriptName_error_wrongPath,
		ru: ru.tab_config_python_scriptName_error_wrongPath
	}[options.languageTag ?? languageTag()]()
}

